import { useState, useEffect, useRef } from 'react';
import '@/App.css';
import axios from 'axios';
import { MessageCircle, X, Send, Package, Truck, Phone, Mail, MapPin, ChevronDown, Menu, Clock, Award, Users, CheckCircle, Upload, ShoppingBag, Sparkles, ShoppingCart } from 'lucide-react';
import AdminPanel from './AdminPanel';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Dev-only logger: silences errors in production to avoid leaking info via console
const devError = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console.error(...args);
  }
};

const LOGO_URL = 'https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/2awi8sg7_logo%20impreplastico%2001-03.png';

// Imágenes de bolsas
const BAG_IMAGE_WHITE_BOUTIQUE = 'https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/8lvanixf_bolsa%20web.png';
const BAG_IMAGE_WHITE_FUELLE = 'https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/cut6rira_bolsa%20con%20fuelle-06.png';
const BAG_IMAGE_BLACK = 'https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/mf0ra96w_Kova%20Store%20-04.png';
const BAG_IMAGE_TRANSPARENT = 'https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/8qwykoja_bolsa%20transparente_Mesa%20de%20trabajo%201.png';

// Datos de precios y tallas ACTUALIZADOS
const pricingData = {
  S_WHITE: {
    name: 'Talla S',
    subtitle: 'SIN FUELLE',
    dimensions: '20 × 29 cm',
    width: '20cm',
    height: '29cm',
    gusset: null,
    prices: { 1: 0.35, 2: 0.40, 3: 0.45 },
    examples: 'Ideal para: Accesorios pequeños, Joyería, Cosméticos',
    color: 'white',
    colorName: 'Blanca',
    discount: 0,
    isNew: false,
    hasGusset: false
  },
  S_BLACK: {
    name: 'Talla S',
    subtitle: 'NEGRA · INCLUYE ENVÍO',
    dimensions: '20 × 29 cm',
    width: '20cm',
    height: '29cm',
    gusset: null,
    prices: { 1: 0.35 },
    examples: 'Ideal para: Accesorios pequeños elegantes',
    color: 'black',
    colorName: 'Negra',
    discount: 0,
    isNew: false,
    hasGusset: false,
    shippingIncluded: true,
    volumeDiscount: true
  },
  M_WHITE: {
    name: 'Talla M',
    subtitle: 'CON FUELLE',
    dimensions: '35 × 38 cm',
    width: '35cm',
    height: '38cm',
    gusset: '+ 5cm Fuelle',
    prices: { 1: 0.45, 2: 0.52, 3: 0.58 },
    examples: 'Ideal para: Camisetas, Gorras, Electrónicos medianos',
    color: 'white',
    colorName: 'Blanca',
    discount: 0,
    isNew: true,
    hasGusset: true
  },
  M_BLACK: {
    name: 'Talla M',
    subtitle: 'NEGRA · INCLUYE ENVÍO',
    dimensions: '30 × 40 cm',
    width: '30cm',
    height: '40cm',
    gusset: null,
    prices: { 1: 0.43 },
    examples: 'Ideal para: Ropa, Accesorios elegantes',
    color: 'black',
    colorName: 'Negra',
    discount: 0,
    isNew: false,
    hasGusset: false,
    shippingIncluded: true,
    volumeDiscount: true
  },
  L_WHITE: {
    name: 'Talla L',
    subtitle: 'CON FUELLE',
    dimensions: '40 × 45 cm',
    width: '40cm',
    height: '45cm',
    gusset: '+ 5cm Fuelle',
    prices: { 1: 0.53, 2: 0.60, 3: 0.68 },
    examples: 'Ideal para: Zapatos, Suéteres, Pedidos combinados',
    color: 'white',
    colorName: 'Blanca',
    discount: 0,
    isNew: true,
    hasGusset: true
  },
  L_BLACK: {
    name: 'Talla L',
    subtitle: 'NEGRA · INCLUYE ENVÍO',
    dimensions: '40 × 50 cm',
    width: '40cm',
    height: '50cm',
    gusset: null,
    prices: { 1: 0.54 },
    examples: 'Ideal para: Zapatos, Ropa elegante',
    color: 'black',
    colorName: 'Negra',
    discount: 0,
    isNew: false,
    hasGusset: false,
    shippingIncluded: true,
    volumeDiscount: true
  },
  XL_WHITE: {
    name: 'Talla XL',
    subtitle: 'CON FUELLE',
    dimensions: '50 × 55 cm',
    width: '50cm',
    height: '55cm',
    gusset: '+ 5cm Fuelle',
    prices: { 1: 0.65, 2: 0.72, 3: 0.78 },
    examples: 'Ideal para: Cajas grandes, Múltiples productos',
    color: 'white',
    colorName: 'Blanca',
    discount: 0,
    isNew: true,
    hasGusset: true
  },
  TRANSPARENT: {
    name: 'Transparente',
    subtitle: 'ECONÓMICA',
    dimensions: '39 × 55 cm',
    width: '39cm',
    height: '55cm',
    gusset: null,
    prices: { 1: 0.65, 2: 0.72, 3: 0.78 },
    examples: 'Ideal para: Mostrar el producto, Tiendas económicas',
    color: 'transparent',
    colorName: 'Transparente',
    discount: 20,
    isNew: false,
    hasGusset: false
  }
};

const faqData = [
  { q: '¿Cuál es el pedido mínimo?', a: 'El pedido mínimo es de 100 unidades. Esto nos permite mantener precios competitivos y calidad constante.' },
  { q: '¿Cuánto tiempo tarda la producción?', a: 'El tiempo de producción estándar es de 7-10 días hábiles después de aprobar el diseño. Para pedidos urgentes, consultanos disponibilidad.' },
  { q: '¿Puedo enviar mi propio diseño?', a: 'Sí, aceptamos diseños en formatos PNG, JPG, PDF o AI. Nuestro equipo lo revisará para asegurar que se imprima correctamente.' },
  { q: '¿Ofrecen servicio de diseño gráfico?', a: 'Sí, contamos con asesoría en diseño para que tu logo se adapte perfectamente a las bolsas y luzca profesional.' },
  { q: '¿Qué métodos de pago aceptan?', a: 'Aceptamos transferencias bancarias, Pago Móvil, Zelle y efectivo. Se requiere 50% de adelanto para iniciar producción.' },
  { q: '¿Hacen envíos a otras ciudades?', a: 'Sí, realizamos envíos a todo el país. El envío es GRATIS en pedidos mayores a 500 unidades.' },
  { q: '¿Los precios incluyen impresión?', a: 'Sí, todos nuestros precios incluyen la impresión de tu diseño en los colores seleccionados.' },
  { q: '¿Puedo ver una muestra antes de producir?', a: 'Sí, ofrecemos una propuesta digital GRATUITA para que veas cómo quedará tu diseño antes de producir.' }
];

// Navbar Component
function Navbar({ scrollToSection, cartCount = 0, onOpenCart }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Inicio', id: 'hero' },
    { label: 'Tallas y Precios', id: 'precios' },
    { label: '🚗 Alfombras', id: 'alfombras-promo' },
    { label: '🎨 Propuesta Digital', id: 'propuesta-digital' },
    { label: '👕 Impresión Textil', id: 'impresion-textil' },
    { label: 'Nosotros', id: 'nosotros' },
    { label: 'Servicios', id: 'servicios' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contacto', id: 'contacto' }
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <img src={LOGO_URL} alt="Impreplástico" className="h-14 md:h-20" />
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map(item => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-cyan-600 font-medium transition"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => window.open('https://wa.me/584147552221', '_blank')}
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-full font-semibold hover:shadow-lg transition"
            >
              Cotizar Ahora
            </button>
            <button
              onClick={onOpenCart}
              data-testid="navbar-cart-btn"
              className="relative bg-slate-900 hover:bg-slate-800 text-white p-2.5 rounded-full transition shadow-lg"
              aria-label="Ver carrito"
            >
              <ShoppingCart className="w-5 h-5" />
              {cartCount > 0 && (
                <span data-testid="navbar-cart-count" className="absolute -top-1 -right-1 bg-yellow-400 text-slate-900 text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center">{cartCount}</span>
              )}
            </button>
          </div>

          {/* Mobile cart + Menu Button */}
          <div className="md:hidden flex items-center gap-2">
            <button
              onClick={onOpenCart}
              data-testid="navbar-cart-btn-mobile"
              className="relative bg-slate-900 text-white p-2 rounded-full"
              aria-label="Ver carrito"
            >
              <ShoppingCart className="w-5 h-5" />
              {cartCount > 0 && <span className="absolute -top-1 -right-1 bg-yellow-400 text-slate-900 text-[9px] font-black rounded-full w-4 h-4 flex items-center justify-center">{cartCount}</span>}
            </button>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 text-gray-700"
            >
              <Menu className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4">
            {navItems.map(item => (
              <button
                key={item.id}
                onClick={() => {
                  scrollToSection(item.id);
                  setIsOpen(false);
                }}
                className="block w-full text-left py-2 text-gray-700 hover:text-cyan-600"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => window.open('https://wa.me/584147552221', '_blank')}
              className="w-full mt-2 bg-gradient-to-r from-cyan-500 to-magenta-500 text-white px-6 py-2 rounded-full font-semibold"
            >
              Cotizar Ahora
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}


// World Cup Shirt Component - Urban Style with BCV Rate
function WorldCupShirt({ country, flag, frontImage, backImage, slogan, accentColor, price, tasaBcv, onBuyClick }) {
  const [selectedSize, setSelectedSize] = useState('M');
  const [showBack, setShowBack] = useState(false);
  const sizes = ['S', 'M', 'L', 'XL', '2XL', '3XL'];

  const colorClasses = {
    green: 'from-green-600 to-green-400 shadow-green-500/30',
    sky: 'from-sky-600 to-sky-400 shadow-sky-500/30',
    red: 'from-red-600 to-red-400 shadow-red-500/30',
    yellow: 'from-yellow-500 to-yellow-400 shadow-yellow-500/30',
    black: 'from-gray-800 to-gray-600 shadow-gray-500/30'
  };

  const priceBs = tasaBcv ? (price * tasaBcv).toFixed(2) : '---';

  const handleBuy = () => {
    if (onBuyClick) {
      onBuyClick({
        country,
        flag,
        size: selectedSize,
        priceUsd: price,
        priceBs: parseFloat(priceBs),
        tasaBcv
      });
    }
  };

  return (
    <div className="group bg-gradient-to-b from-gray-900 to-black rounded-2xl overflow-hidden border border-white/10 hover:border-white/30 transition-all duration-500 hover:shadow-2xl hover:shadow-white/10">
      {/* Image Container */}
      <div 
        className="relative h-64 cursor-pointer overflow-hidden"
        onClick={() => setShowBack(!showBack)}
      >
        {/* Gradient overlay */}
        <div className={`absolute inset-0 bg-gradient-to-br ${colorClasses[accentColor]} opacity-20`}></div>
        
        <img 
          src={showBack ? backImage : frontImage}
          alt={`Camiseta ${country}`}
          className="w-full h-full object-contain p-3 transform group-hover:scale-110 transition-transform duration-500"
        />
        
        {/* Country badge */}
        <div className="absolute top-2 left-2 bg-black/80 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs font-black flex items-center gap-1 border border-white/20">
          <span>{flag}</span>
          <span className="uppercase tracking-wider">{country}</span>
        </div>
        
        {/* Gift badge */}
        <div className="absolute top-2 right-2 bg-yellow-500 text-black px-2 py-0.5 rounded-full text-[10px] font-black">
          +CALENDARIO
        </div>
        
        {/* Toggle hint */}
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-white/10 backdrop-blur-sm text-white/80 px-3 py-0.5 rounded-full text-[10px]">
          Toca para ver {showBack ? 'frente' : 'espalda'}
        </div>
      </div>

      {/* Details */}
      <div className="p-4">
        <p className="text-gray-500 text-xs italic mb-2">"{slogan}"</p>
        
        <div className="mb-3">
          <div className="flex items-baseline gap-2">
            <span className={`text-2xl font-black bg-gradient-to-r ${colorClasses[accentColor]} bg-clip-text text-transparent`}>
              ${price}
            </span>
            <span className="text-xs text-gray-500">USD</span>
          </div>
          <div className="text-sm text-green-400 font-semibold">
            Bs. {priceBs}
          </div>
        </div>

        {/* Size Selector */}
        <div className="mb-3">
          <label className="block text-[10px] font-bold text-gray-400 mb-1 uppercase tracking-wider">Talla</label>
          <div className="grid grid-cols-6 gap-1">
            {sizes.map(size => (
              <button
                key={size}
                onClick={() => setSelectedSize(size)}
                className={`py-1.5 rounded text-[10px] font-bold transition-all duration-200 ${
                  selectedSize === size 
                    ? `bg-gradient-to-r ${colorClasses[accentColor]} text-white shadow-lg` 
                    : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'
                }`}
              >
                {size}
              </button>
            ))}
          </div>
        </div>

        {/* Buy Button */}
        <button
          onClick={handleBuy}
          className="w-full bg-gradient-to-r from-green-500 to-green-400 hover:from-green-400 hover:to-green-300 text-black py-2.5 rounded-xl font-black text-xs flex items-center justify-center gap-2 transition-all duration-300 shadow-lg shadow-green-500/30 hover:shadow-green-500/50"
        >
          <MessageCircle className="w-4 h-4" />
          COMPRAR
        </button>
      </div>
    </div>
  );
}

// Modal de compra con formulario completo
function PurchaseModal({ isOpen, onClose, orderData, tasaBcv }) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    mrwAddress: '',
    paymentCapture: null
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  if (!isOpen || !orderData) return null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setFormData(prev => ({ ...prev, paymentCapture: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.phone || !formData.mrwAddress) {
      alert('Por favor completa todos los campos obligatorios');
      return;
    }

    if (!formData.paymentCapture) {
      alert('Por favor sube el capture del pago');
      return;
    }

    // Construir mensaje de WhatsApp
    const message = `🛒 *PEDIDO CAMISETA MUNDIAL 2026*

⚽ *Selección:* ${orderData.country} ${orderData.flag}
📏 *Talla:* ${orderData.size}
💵 *Precio:* $${orderData.priceUsd} / Bs. ${orderData.priceBs.toFixed(2)}
📊 *Tasa BCV:* ${tasaBcv}

👤 *Cliente:* ${formData.name}
📱 *Teléfono:* ${formData.phone}
📦 *Agencia MRW:* ${formData.mrwAddress}

💳 *Pago realizado vía Pago Móvil*
✅ *Capture de pago:* Te lo envío a continuación

🎁 *Incluye:* Calendario del Mundial GRATIS

¡Confirmo mi pedido!`;

    window.open(`https://wa.me/584147552221?text=${encodeURIComponent(message)}`, '_blank');
    onClose();
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert('Copiado al portapapeles');
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-900 rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto border border-white/10">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 to-green-500 p-4 flex items-center justify-between">
          <div>
            <h3 className="text-xl font-black text-white">Finalizar Compra</h3>
            <p className="text-green-100 text-sm">{orderData.flag} {orderData.country} - Talla {orderData.size}</p>
          </div>
          <button onClick={onClose} className="text-white hover:bg-white/20 p-2 rounded-lg">
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Resumen del pedido */}
        <div className="p-4 bg-gray-800/50 border-b border-white/10">
          <div className="flex justify-between items-center">
            <span className="text-gray-400">Precio USD:</span>
            <span className="text-2xl font-black text-white">${orderData.priceUsd}</span>
          </div>
          <div className="flex justify-between items-center mt-1">
            <span className="text-gray-400">Precio Bs (Tasa BCV {tasaBcv}):</span>
            <span className="text-xl font-bold text-green-400">Bs. {orderData.priceBs.toFixed(2)}</span>
          </div>
          <div className="mt-2 text-yellow-400 text-sm">🎁 + Calendario del Mundial GRATIS</div>
        </div>

        {/* Datos de Pago Móvil */}
        <div className="p-4 bg-blue-900/30 border-b border-white/10">
          <h4 className="text-white font-bold mb-3 flex items-center gap-2">
            💳 Pago Móvil - Banco Mercantil
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between items-center bg-gray-800/50 p-2 rounded-lg">
              <span className="text-gray-400">Teléfono:</span>
              <div className="flex items-center gap-2">
                <span className="text-white font-mono">0414-7479327</span>
                <button onClick={() => copyToClipboard('04147479327')} className="text-cyan-400 hover:text-cyan-300 text-xs">Copiar</button>
              </div>
            </div>
            <div className="flex justify-between items-center bg-gray-800/50 p-2 rounded-lg">
              <span className="text-gray-400">Cédula:</span>
              <div className="flex items-center gap-2">
                <span className="text-white font-mono">V-8030568</span>
                <button onClick={() => copyToClipboard('8030568')} className="text-cyan-400 hover:text-cyan-300 text-xs">Copiar</button>
              </div>
            </div>
            <div className="flex justify-between items-center bg-gray-800/50 p-2 rounded-lg">
              <span className="text-gray-400">Nombre:</span>
              <span className="text-white">Ilba Sánchez</span>
            </div>
            <div className="flex justify-between items-center bg-gray-800/50 p-2 rounded-lg">
              <span className="text-gray-400">Banco:</span>
              <span className="text-white">Mercantil (0105)</span>
            </div>
            <div className="flex justify-between items-center bg-yellow-500/20 p-2 rounded-lg border border-yellow-500/50">
              <span className="text-yellow-400">Monto:</span>
              <span className="text-yellow-400 font-bold">Bs. {orderData.priceBs.toFixed(2)}</span>
            </div>
          </div>
        </div>

        {/* Formulario */}
        <div className="p-4 space-y-4">
          <p className="text-gray-400 text-sm text-center mb-2">Realiza el pago y completa tus datos</p>
          
          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-2">Nombre completo *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
              placeholder="Tu nombre"
              className="w-full bg-gray-800 border border-gray-600 rounded-lg px-4 py-3 text-white focus:border-green-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-2">Número de WhatsApp *</label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
              placeholder="0414-1234567"
              className="w-full bg-gray-800 border border-gray-600 rounded-lg px-4 py-3 text-white focus:border-green-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-2">Dirección de Agencia MRW *</label>
            <textarea
              value={formData.mrwAddress}
              onChange={(e) => setFormData(prev => ({ ...prev, mrwAddress: e.target.value }))}
              placeholder="Ej: MRW Centro Comercial El Recreo, Caracas"
              rows={2}
              className="w-full bg-gray-800 border border-gray-600 rounded-lg px-4 py-3 text-white focus:border-green-500 focus:outline-none resize-none"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-300 mb-2">Capture del pago *</label>
            <div className={`border-2 border-dashed rounded-lg p-4 text-center transition cursor-pointer ${previewImage ? 'border-green-500 bg-green-500/10' : 'border-gray-600 hover:border-green-500'}`}
                 onClick={() => document.getElementById('paymentCapture').click()}>
              {previewImage ? (
                <div>
                  <img src={previewImage} alt="Preview" className="max-h-32 mx-auto rounded mb-2" />
                  <p className="text-green-400 text-sm">✅ Capture cargado</p>
                </div>
              ) : (
                <>
                  <Upload className="w-8 h-8 mx-auto text-gray-500 mb-2" />
                  <p className="text-gray-400 text-sm">Toca para subir capture del pago</p>
                </>
              )}
              <input
                type="file"
                id="paymentCapture"
                accept="image/*"
                onChange={handleFileChange}
                className="hidden"
              />
            </div>
          </div>
        </div>

        {/* Botón de enviar */}
        <div className="p-4 border-t border-white/10">
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="w-full bg-gradient-to-r from-green-500 to-green-400 hover:from-green-400 hover:to-green-300 text-black py-4 rounded-xl font-black text-lg flex items-center justify-center gap-2 transition-all duration-300"
          >
            <MessageCircle className="w-6 h-6" />
            ENVIAR PEDIDO POR WHATSAPP
          </button>
          <p className="text-center text-gray-500 text-xs mt-2">Envía el capture del pago junto con tu pedido</p>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// COMBO PROMO MODAL — Asistente de venta auto-guiado (4 pasos)
// ============================================================
const COMBO_PRICE_USD = 60;
const COMBO_REGULAR_USD = 80; // S=$35 + M=$45
const COMBO_SAVINGS_PCT = Math.round((1 - COMBO_PRICE_USD / COMBO_REGULAR_USD) * 100);
const COMBO_DEADLINE = new Date('2026-07-15T23:59:59-04:00');
const OWNER_WHATSAPP = '584147552221';

function ComboModal({ isOpen, onClose, tasaBcv, alfombrasOrderData }) {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    company: '',
    mrwAddress: '',
    city: '',
    digitalProposal: true,
    paymentCapture: null
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [generatedCode, setGeneratedCode] = useState('');
  const [receiptUrl, setReceiptUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      // Reset al cerrar
      setStep(1);
      setFormData({ name: '', phone: '', company: '', mrwAddress: '', city: '', digitalProposal: true, paymentCapture: null });
      setPreviewImage(null);
      setGeneratedCode('');
      setReceiptUrl('');
      setError('');
    } else {
      // Track: usuario abrió el modal (interés en la oferta)
      if (typeof window !== 'undefined' && window.fbq) {
        const isAlf = !!alfombrasOrderData;
        window.fbq('track', 'ViewContent', {
          content_name: isAlf ? 'Alfombras Carro' : 'Combo S+M',
          content_category: isAlf ? 'Alfombras Web' : 'Combo Promo Web',
          content_ids: [isAlf ? 'alfombras-carro' : 'combo-sm'],
          value: isAlf ? alfombrasOrderData.priceUsd : COMBO_PRICE_USD,
          currency: 'USD'
        });
      }
    }
  }, [isOpen, alfombrasOrderData]);

  if (!isOpen) return null;

  const priceBs = tasaBcv ? (COMBO_PRICE_USD * tasaBcv).toFixed(2) : '---';
  const regularBs = tasaBcv ? (COMBO_REGULAR_USD * tasaBcv).toFixed(2) : '---';

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setError('La imagen debe ser menor a 5MB');
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setFormData(prev => ({ ...prev, paymentCapture: reader.result }));
        setError('');
      };
      reader.readAsDataURL(file);
    }
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    setError(`✓ ${label} copiado`);
    setTimeout(() => setError(''), 1500);
  };

  const validateStep2 = () => {
    if (!formData.name.trim() || !formData.phone.trim()) {
      setError('Por favor completa todos los campos obligatorios (*)');
      return false;
    }
    if (alfombrasOrderData) {
      if (!formData.city.trim()) {
        setError('Por favor indica tu ciudad');
        return false;
      }
    } else if (!formData.mrwAddress.trim()) {
      setError('Por favor completa todos los campos obligatorios (*)');
      return false;
    }
    if (formData.phone.replace(/\D/g, '').length < 10) {
      setError('El número de WhatsApp debe tener al menos 10 dígitos');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!formData.paymentCapture) {
      setError('Por favor sube el capture del pago');
      return;
    }
    setIsSubmitting(true);
    setError('');
    try {
      let response;
      if (alfombrasOrderData) {
        // Pedido de Alfombras
        const alfPriceBs = tasaBcv ? +(alfombrasOrderData.priceUsd * tasaBcv).toFixed(2) : 0;
        response = await axios.post(`${API}/alfombras-order`, {
          client_name: formData.name,
          client_phone: formData.phone,
          business_name: formData.company || 'No especificado',
          city: formData.city || 'No especificada',
          quantity: alfombrasOrderData.quantity,
          bonus: alfombrasOrderData.bonus,
          total_units: alfombrasOrderData.totalUnits,
          print_colors: alfombrasOrderData.printColors || 1,
          additional_colors_cost: alfombrasOrderData.additionalColorsCost || 0,
          base_price_usd: alfombrasOrderData.basePriceUsd || alfombrasOrderData.priceUsd,
          price_usd: alfombrasOrderData.priceUsd,
          price_bs: alfPriceBs,
          tasa_bcv: tasaBcv || 0,
          digital_proposal_requested: !!formData.digitalProposal,
          payment_capture: formData.paymentCapture
        });
      } else {
        response = await axios.post(`${API}/combo-order`, {
          client_name: formData.name,
          client_phone: formData.phone,
          company_name: formData.company || 'No especificado',
          mrw_address: formData.mrwAddress,
          price_usd: COMBO_PRICE_USD,
          price_bs: parseFloat(priceBs),
          tasa_bcv: tasaBcv || 0,
          payment_capture: formData.paymentCapture
        });
      }
      setGeneratedCode(response.data.code);
      setReceiptUrl(response.data.receipt_url || '');
      setStep(4);

      // Track: compra confirmada
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'Purchase', {
          value: alfombrasOrderData ? alfombrasOrderData.priceUsd : COMBO_PRICE_USD,
          currency: 'USD',
          content_name: alfombrasOrderData ? 'Alfombras Carro' : 'Combo S+M',
          content_type: 'product',
          num_items: alfombrasOrderData ? alfombrasOrderData.quantity : 200,
          order_id: response.data.code
        });
      }
    } catch (e) {
      setError('Error al procesar el pedido. Inténtalo de nuevo o contáctanos por WhatsApp.');
      devError(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const sendToOwnerWhatsApp = () => {
    // El cliente envía al dueño el código + link al comprobante
    const receiptFullUrl = receiptUrl ? `${BACKEND_URL}${receiptUrl}` : '(comprobante en sistema)';
    let ownerMsg;
    if (alfombrasOrderData) {
      const alfPriceBs = tasaBcv ? (alfombrasOrderData.priceUsd * tasaBcv).toFixed(2) : '---';
      ownerMsg = `🚗 *CONFIRMACIÓN DE MI PEDIDO*
_Alfombras para Carro Personalizadas · Impreplástico_

🎟️ *Mi código único:* ${generatedCode}

👤 *Mis datos:*
• Nombre: ${formData.name}
• WhatsApp: ${formData.phone}
• Empresa/Marca: ${formData.company || 'No especificado'}
• Ciudad: ${formData.city}

📦 *Detalle del pedido:*
• Alfombras compradas: ${alfombrasOrderData.quantity}
• Alfombras GRATIS: ${alfombrasOrderData.bonus}
• Total a recibir: ${alfombrasOrderData.totalUnits}
• Impresión: ${alfombrasOrderData.printColors || 1} color${(alfombrasOrderData.printColors || 1) > 1 ? 'es' : ''}
• Propuesta digital: ${formData.digitalProposal ? 'Sí, por favor' : 'No'}

💰 *Pago realizado:* $${alfombrasOrderData.priceUsd} USD / Bs. ${alfPriceBs}
📊 Tasa BCV: ${tasaBcv}
⚠️ Envío NO incluido (se cotiza aparte)

📸 *Comprobante:*
${receiptFullUrl}

Quedo a la espera de mi propuesta digital y confirmación. ¡Gracias!`;
    } else {
      ownerMsg = `✅ *CONFIRMACIÓN DE MI PEDIDO*
_Combo S + M · Impreplástico_

🎟️ *Mi código único:* ${generatedCode}

👤 *Mis datos:*
• Nombre: ${formData.name}
• WhatsApp: ${formData.phone}
• Empresa/Marca: ${formData.company || 'No especificado'}
• Agencia MRW: ${formData.mrwAddress}

💰 *Pago realizado:* $${COMBO_PRICE_USD} USD / Bs. ${priceBs}
📊 Tasa BCV: ${tasaBcv}

📸 *Comprobante:*
${receiptFullUrl}

Quedo a la espera de mi propuesta digital en las próximas 48 horas. ¡Gracias!`;
    }
    window.open(`https://wa.me/${OWNER_WHATSAPP}?text=${encodeURIComponent(ownerMsg)}`, '_blank');
  };

  const stepTitles = alfombrasOrderData
    ? ['Tus Alfombras', 'Tus Datos', 'Realiza el Pago', '¡Listo!']
    : ['Tu Combo', 'Tus Datos', 'Realiza el Pago', '¡Listo!'];

  return (
    <div className="fixed inset-0 bg-black/85 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="combo-modal">
      <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[92vh] overflow-y-auto shadow-2xl">
        {/* Header con progreso */}
        <div className="sticky top-0 bg-gradient-to-r from-slate-900 via-teal-800 to-cyan-700 p-5 z-10">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-white/80 text-xs font-bold tracking-widest">{alfombrasOrderData ? '🚗 ALFOMBRAS PERSONALIZADAS' : 'COMBO EXCLUSIVO WEB'}</p>
              <h3 className="text-2xl font-black text-white">Paso {step} de 4: {stepTitles[step - 1]}</h3>
            </div>
            <button onClick={onClose} data-testid="combo-modal-close" className="text-white hover:bg-white/20 p-2 rounded-full transition">
              <X className="w-6 h-6" />
            </button>
          </div>
          {/* Barra de progreso */}
          <div className="flex gap-1.5">
            {[1, 2, 3, 4].map(s => (
              <div key={s} className={`flex-1 h-1.5 rounded-full transition-all ${s <= step ? 'bg-yellow-300' : 'bg-white/20'}`}></div>
            ))}
          </div>
        </div>

        {/* STEP 1: Bienvenida + detalle combo */}
        {step === 1 && (
          <div className="p-6 space-y-5">
            {alfombrasOrderData ? (
              <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-5 text-white">
                <h4 className="text-xl font-black mb-3 flex items-center gap-2"><span className="text-2xl">🚗</span> Tu Pedido de Alfombras</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between border-b border-white/10 pb-1"><span className="text-slate-300">Alfombras compradas:</span><span className="font-black tabular-nums">{alfombrasOrderData.quantity}</span></div>
                  <div className="flex justify-between border-b border-white/10 pb-1"><span className="text-slate-300">Alfombras GRATIS:</span><span className="font-black text-emerald-400 tabular-nums">{alfombrasOrderData.bonus}</span></div>
                  <div className="flex justify-between border-b border-white/10 pb-1"><span className="text-slate-300">Total recibido:</span><span className="font-black text-yellow-300 tabular-nums text-base">{alfombrasOrderData.totalUnits}</span></div>
                  <div className="flex justify-between border-b border-white/10 pb-1"><span className="text-slate-300">Impresión:</span><span className="font-black tabular-nums">{alfombrasOrderData.printColors || 1} {(alfombrasOrderData.printColors || 1) === 1 ? 'color' : 'colores'}</span></div>
                  <div className="flex justify-between items-baseline pt-2"><span className="text-slate-300 font-bold">Total a pagar:</span><span className="text-3xl font-black text-white tabular-nums">${alfombrasOrderData.priceUsd}</span></div>
                  {tasaBcv && <p className="text-right text-xs text-emerald-400">Bs. {(alfombrasOrderData.priceUsd * tasaBcv).toFixed(2)}</p>}
                </div>
                <div className="mt-4 bg-cyan-500/20 border border-cyan-400/40 rounded-lg p-3 text-xs text-cyan-100">🎨 Impresión de calidad · Propuesta digital previa · ⚠️ Envío NO incluido</div>
              </div>
            ) : (
            <>
            <div className="bg-gradient-to-br from-teal-50 via-cyan-50 to-emerald-50 rounded-2xl p-5 border-2 border-cyan-200">
              <h4 className="text-xl font-black text-gray-800 mb-3 flex items-center gap-2">
                <span className="text-2xl">🎁</span> Tu Combo incluye:
              </h4>
              <div className="space-y-3">
                <div className="flex items-center gap-3 bg-white rounded-xl p-3 shadow-sm">
                  <div className="w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center text-2xl">📦</div>
                  <div className="flex-1">
                    <p className="font-black text-gray-800">100 Bolsas Talla S</p>
                    <p className="text-xs text-gray-500">20×29 cm · Sin fuelle · Impresión a 1 color</p>
                  </div>
                  <span className="font-bold text-cyan-600">$15</span>
                </div>
                <div className="flex items-center gap-3 bg-white rounded-xl p-3 shadow-sm">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center text-2xl">📦</div>
                  <div className="flex-1">
                    <p className="font-black text-gray-800">100 Bolsas Talla M</p>
                    <p className="text-xs text-gray-500">35×38 cm · Con fuelle · Impresión a 1 color</p>
                  </div>
                  <span className="font-bold text-teal-600">$45</span>
                </div>
                <div className="flex items-center gap-3 bg-white rounded-xl p-3 shadow-sm">
                  <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center text-2xl">✏️</div>
                  <div className="flex-1">
                    <p className="font-black text-gray-800">Propuesta Digital incluida</p>
                    <p className="text-xs text-gray-500">Diseño + adaptación + asesoría · Entrega &lt;48h</p>
                  </div>
                  <span className="font-bold text-green-600">GRATIS</span>
                </div>
              </div>
            </div>

            {/* Precio destacado */}
            <div className="bg-gradient-to-br from-slate-900 to-teal-900 rounded-2xl p-5 text-white">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-white/60 text-xs uppercase tracking-wider">Precio combo</p>
                  <div className="flex items-baseline gap-2 mt-1">
                    <span className="text-5xl font-black bg-gradient-to-r from-yellow-300 to-orange-400 bg-clip-text text-transparent">${COMBO_PRICE_USD}</span>
                    <span className="text-lg text-gray-400 line-through">${COMBO_REGULAR_USD}</span>
                  </div>
                  {tasaBcv && <p className="text-green-400 font-bold text-sm mt-1">Bs. {priceBs} <span className="text-gray-400 text-xs">(BCV {tasaBcv})</span></p>}
                </div>
                <div className="bg-yellow-400 text-black font-black px-4 py-3 rounded-2xl rotate-3 shadow-lg">
                  <p className="text-3xl leading-none">-{COMBO_SAVINGS_PCT}%</p>
                  <p className="text-[10px] uppercase">ahorro</p>
                </div>
              </div>
            </div>

            {/* Disclaimers */}
            <div className="bg-red-50 border-2 border-red-300 rounded-xl p-4 space-y-2">
              <p className="font-black text-red-700 flex items-center gap-2">⚠️ Importante:</p>
              <ul className="text-sm text-gray-700 space-y-1.5">
                <li className="flex items-start gap-2"><span className="text-red-600 font-bold">●</span> <span><strong>Precio especial SOLO vía web.</strong> No se ofrece por WhatsApp ni en tienda física.</span></li>
                <li className="flex items-start gap-2"><span className="text-red-600 font-bold">●</span> <span><strong>Pago completo por adelantado.</strong> Esto activa la creación de tu propuesta digital.</span></li>
                <li className="flex items-start gap-2"><span className="text-red-600 font-bold">●</span> <span><strong>Impresión a 1 color.</strong> El logo o diseño se imprime en una sola tinta.</span></li>
                <li className="flex items-start gap-2"><span className="text-red-600 font-bold">●</span> <span><strong>NO incluye envío.</strong> Se cotiza aparte según tu ubicación (MRW).</span></li>
                <li className="flex items-start gap-2"><span className="text-green-600 font-bold">✓</span> <span><strong>Sí incluye:</strong> Propuesta digital + adaptación de logo + asesoría completa.</span></li>
                <li className="flex items-start gap-2"><span className="text-yellow-600 font-bold">⏰</span> <span><strong>Vigencia:</strong> hasta el 15 de julio 2026.</span></li>
              </ul>
            </div>
            </>
            )}

            <button
              onClick={() => setStep(2)}
              data-testid="combo-step1-continue"
              className="w-full bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white py-4 rounded-2xl font-black text-lg shadow-xl hover:shadow-2xl transition-all hover:scale-[1.02]"
            >
              {alfombrasOrderData ? 'QUIERO MIS ALFOMBRAS →' : 'QUIERO MI COMBO →'}
            </button>
          </div>
        )}

        {/* STEP 2: Formulario datos */}
        {step === 2 && (
          <div className="p-6 space-y-4">
            <p className="text-gray-600 text-sm bg-blue-50 border border-blue-200 rounded-lg p-3">
              👋 Llena tus datos para identificar tu pedido. Te contactaremos a este WhatsApp con tu propuesta digital.
            </p>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">Nombre completo *</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                data-testid="combo-input-name"
                placeholder="Tu nombre"
                className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:border-teal-500 focus:bg-white focus:outline-none transition"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">WhatsApp *</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
                data-testid="combo-input-phone"
                placeholder="0414-1234567"
                className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:border-teal-500 focus:bg-white focus:outline-none transition"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">Nombre de tu marca / negocio</label>
              <input
                type="text"
                value={formData.company}
                onChange={(e) => setFormData(prev => ({ ...prev, company: e.target.value }))}
                data-testid="combo-input-company"
                placeholder="Ej: Mi Tienda VZ"
                className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:border-teal-500 focus:bg-white focus:outline-none transition"
              />
            </div>

            {alfombrasOrderData ? (
              <>
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-1.5">Ciudad *</label>
                  <input
                    type="text"
                    value={formData.city}
                    onChange={(e) => setFormData(prev => ({ ...prev, city: e.target.value }))}
                    data-testid="combo-input-city"
                    placeholder="Ej: Caracas, Maracaibo, Valencia..."
                    className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:border-teal-500 focus:bg-white focus:outline-none transition"
                  />
                  <p className="text-xs text-gray-500 mt-1">⚠️ Envío NO incluido. Lo cotizamos aparte según tu ubicación.</p>
                </div>

                <label className="flex items-start gap-3 bg-cyan-50 border-2 border-cyan-200 rounded-xl p-3 cursor-pointer hover:bg-cyan-100 transition">
                  <input
                    type="checkbox"
                    checked={formData.digitalProposal}
                    onChange={(e) => setFormData(prev => ({ ...prev, digitalProposal: e.target.checked }))}
                    data-testid="combo-input-proposal"
                    className="mt-1 w-5 h-5 accent-teal-600"
                  />
                  <div>
                    <p className="font-black text-sm text-gray-800">Quiero recibir propuesta digital primero</p>
                    <p className="text-xs text-gray-600 mt-0.5">Diseñamos una vista previa con tu logo antes de imprimir. Sin costo adicional.</p>
                  </div>
                </label>
              </>
            ) : (
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-1.5">Dirección de Agencia MRW *</label>
                <textarea
                  value={formData.mrwAddress}
                  onChange={(e) => setFormData(prev => ({ ...prev, mrwAddress: e.target.value }))}
                  data-testid="combo-input-mrw"
                  placeholder="Ej: MRW Centro Comercial El Recreo, Caracas"
                  rows={2}
                  className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:border-teal-500 focus:bg-white focus:outline-none transition resize-none"
                />
                <p className="text-xs text-gray-500 mt-1">El envío se cotiza aparte al confirmar producción.</p>
              </div>
            )}

            {error && <p className="text-red-600 text-sm font-semibold bg-red-50 p-2 rounded-lg">{error}</p>}

            <div className="flex gap-3 pt-2">
              <button onClick={() => setStep(1)} className="px-5 py-3 rounded-xl border-2 border-gray-300 text-gray-700 font-bold hover:bg-gray-50 transition">
                ← Atrás
              </button>
              <button
                onClick={() => { if (validateStep2()) { setError(''); setStep(3); } }}
                data-testid="combo-step2-continue"
                className="flex-1 bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white py-3 rounded-xl font-black shadow-lg transition-all"
              >
                CONTINUAR AL PAGO →
              </button>
            </div>
          </div>
        )}

        {/* STEP 3: Pago Móvil */}
        {step === 3 && (
          <div className="p-6 space-y-4">
            <div className="bg-gradient-to-br from-blue-900 to-indigo-900 rounded-2xl p-5 text-white">
              <h4 className="text-lg font-black mb-1 flex items-center gap-2">💳 Realiza el Pago Móvil</h4>
              <p className="text-blue-100 text-sm mb-4">Toca cualquier dato para copiarlo</p>

              <div className="space-y-2 text-sm">
                {[
                  { label: 'Teléfono', value: '0414-7479327', copy: '04147479327' },
                  { label: 'Cédula', value: 'V-8030568', copy: '8030568' },
                  { label: 'Nombre', value: 'Ilba Sánchez' },
                  { label: 'Banco', value: 'Mercantil (0105)' }
                ].map((row) => (
                  <button
                    key={row.label}
                    onClick={() => row.copy && copyToClipboard(row.copy, row.label)}
                    className="w-full flex justify-between items-center bg-white/10 hover:bg-white/20 p-3 rounded-lg transition text-left"
                  >
                    <span className="text-blue-200">{row.label}:</span>
                    <span className="text-white font-mono font-bold">{row.value}{row.copy && <span className="ml-2 text-cyan-300 text-xs">📋</span>}</span>
                  </button>
                ))}
                <div className="flex justify-between items-center bg-yellow-400 text-black p-4 rounded-xl border-2 border-yellow-300 shadow-lg mt-3">
                  <span className="font-bold">Monto a pagar:</span>
                  <div className="text-right">
                    <p className="text-2xl font-black">Bs. {alfombrasOrderData ? (tasaBcv ? (alfombrasOrderData.priceUsd * tasaBcv).toFixed(2) : '---') : priceBs}</p>
                    <p className="text-xs">${alfombrasOrderData ? alfombrasOrderData.priceUsd : COMBO_PRICE_USD} USD · BCV {tasaBcv}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Upload comprobante */}
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">Capture del Pago Móvil *</label>
              <div
                className={`border-2 border-dashed rounded-xl p-6 text-center transition cursor-pointer ${previewImage ? 'border-green-500 bg-green-50' : 'border-teal-300 bg-teal-50 hover:bg-teal-100'}`}
                onClick={() => document.getElementById('comboCapture').click()}
                data-testid="combo-upload-area"
              >
                {previewImage ? (
                  <div>
                    <img src={previewImage} alt="Preview" className="max-h-40 mx-auto rounded-lg mb-2 shadow-md" />
                    <p className="text-green-700 font-bold text-sm">✓ Comprobante cargado · Toca para cambiar</p>
                  </div>
                ) : (
                  <>
                    <Upload className="w-10 h-10 mx-auto text-teal-500 mb-2" />
                    <p className="text-teal-700 font-bold">Toca aquí para subir el capture</p>
                    <p className="text-xs text-gray-500 mt-1">JPG o PNG · Máx 5MB</p>
                  </>
                )}
                <input
                  type="file"
                  id="comboCapture"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="hidden"
                />
              </div>
            </div>

            {error && <p className={`text-sm font-semibold p-2 rounded-lg ${error.startsWith('✓') ? 'text-green-700 bg-green-50' : 'text-red-600 bg-red-50'}`}>{error}</p>}

            <div className="flex gap-3 pt-2">
              <button onClick={() => setStep(2)} className="px-5 py-3 rounded-xl border-2 border-gray-300 text-gray-700 font-bold hover:bg-gray-50 transition">
                ← Atrás
              </button>
              <button
                onClick={handleSubmit}
                disabled={isSubmitting || !previewImage}
                data-testid="combo-step3-confirm"
                className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed text-white py-3 rounded-xl font-black shadow-lg transition-all"
              >
                {isSubmitting ? 'Procesando...' : '✓ CONFIRMAR PAGO'}
              </button>
            </div>
          </div>
        )}

        {/* STEP 4: Éxito + código */}
        {step === 4 && (
          <div className="p-6 text-center space-y-5" data-testid="combo-success-screen">
            <div className="w-24 h-24 mx-auto bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-2xl animate-bounce">
              <CheckCircle className="w-14 h-14 text-white" strokeWidth={3} />
            </div>
            <div>
              <h3 className="text-3xl font-black text-gray-800 mb-2">¡Pago Recibido!</h3>
              <p className="text-gray-600">{alfombrasOrderData ? 'Tu pedido de alfombras ha sido registrado' : 'Tu combo exclusivo web ha sido registrado'}</p>
            </div>

            {/* Código único */}
            <div className="bg-gradient-to-br from-teal-50 via-cyan-50 to-emerald-50 rounded-2xl p-5 border-2 border-cyan-300">
              <p className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-2">🎟️ Tu código único e intransferible</p>
              <p className="text-3xl md:text-4xl font-black bg-gradient-to-r from-teal-700 to-cyan-700 bg-clip-text text-transparent tracking-wider font-mono break-all" data-testid="combo-generated-code">
                {generatedCode}
              </p>
              <button
                onClick={() => copyToClipboard(generatedCode, 'Código')}
                className="mt-3 text-sm font-bold text-teal-700 hover:text-teal-900 underline"
              >
                📋 Copiar código
              </button>
              <p className="text-[11px] text-red-600 font-bold mt-3">⚠️ Este código es exclusivo para ti. No puede ser compartido ni transferido.</p>
            </div>

            {/* CTA WhatsApp - acción principal */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-5 border-2 border-green-500 shadow-lg">
              <p className="font-black text-green-800 text-lg mb-1">📲 Último paso</p>
              <p className="text-sm text-gray-700 mb-4">Toca para enviarnos tu código y comprobante por WhatsApp. Así activamos tu propuesta digital en &lt;48h.</p>
              <button
                onClick={sendToOwnerWhatsApp}
                data-testid="combo-send-whatsapp"
                className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 rounded-2xl font-black text-lg shadow-xl flex items-center justify-center gap-3 transition-all hover:scale-[1.02]"
              >
                <MessageCircle className="w-6 h-6" />
                ENVIAR POR WHATSAPP
              </button>
              <p className="text-[10px] text-gray-500 mt-2">📸 El comprobante ya está guardado en nuestro sistema y se incluye automáticamente en el mensaje.</p>
            </div>

            {/* Promesa 48h */}
            <div className="bg-cyan-50 border border-cyan-200 rounded-xl p-3">
              <p className="text-sm text-cyan-800"><strong>⏱️ En menos de 48 horas</strong> recibirás tu propuesta digital en <strong>{formData.phone}</strong></p>
            </div>

            <div className="text-left bg-gray-50 rounded-xl p-4 text-sm space-y-1">
              <p className="font-bold text-gray-700 mb-2">📋 Resumen:</p>
              {alfombrasOrderData ? (
                <>
                  <p className="text-gray-600">• <strong>Producto:</strong> {alfombrasOrderData.quantity} Alfombras {alfombrasOrderData.bonus > 0 && <span className="text-emerald-700 font-bold">+ {alfombrasOrderData.bonus} GRATIS</span>}</p>
                  <p className="text-gray-600">• <strong>Total a recibir:</strong> {alfombrasOrderData.totalUnits} unidades</p>
                  <p className="text-gray-600">• <strong>Impresión:</strong> {alfombrasOrderData.printColors || 1} color{(alfombrasOrderData.printColors || 1) > 1 ? 'es' : ''}</p>
                  <p className="text-gray-600">• <strong>Pagado:</strong> ${alfombrasOrderData.priceUsd} USD {tasaBcv && `(Bs. ${(alfombrasOrderData.priceUsd * tasaBcv).toFixed(2)})`}</p>
                  <p className="text-gray-600">• <strong>Cliente:</strong> {formData.name} · {formData.city}</p>
                </>
              ) : (
                <>
                  <p className="text-gray-600">• <strong>Combo:</strong> 100 Talla S + 100 Talla M</p>
                  <p className="text-gray-600">• <strong>Pagado:</strong> ${COMBO_PRICE_USD} USD (Bs. {priceBs})</p>
                  <p className="text-gray-600">• <strong>Cliente:</strong> {formData.name}</p>
                </>
              )}
            </div>

            <button
              onClick={onClose}
              data-testid="combo-success-close"
              className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-2xl font-bold transition"
            >
              Cerrar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function BagPurchaseModal({ isOpen, onClose, orderData, tasaBcv }) {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ name: '', phone: '', company: '', mrwAddress: '', paymentCapture: null });
  const [previewImage, setPreviewImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [generatedCode, setGeneratedCode] = useState('');
  const [receiptUrl, setReceiptUrl] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setStep(1);
      setFormData({ name: '', phone: '', company: '', mrwAddress: '', paymentCapture: null });
      setPreviewImage(null);
      setGeneratedCode('');
      setReceiptUrl('');
      setError('');
    } else if (orderData) {
      // Track: intención de compra de bolsa individual
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_name: orderData.productName,
          content_ids: [orderData.sizeKey],
          value: orderData.priceUsd,
          currency: 'USD',
          num_items: orderData.quantity
        });
      }
    }
  }, [isOpen, orderData]);

  if (!isOpen || !orderData) return null;

  const priceBsFormatted = orderData.priceBs ? orderData.priceBs.toFixed(2) : '---';

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { setError('La imagen debe ser menor a 5MB'); return; }
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewImage(reader.result);
      setFormData(prev => ({ ...prev, paymentCapture: reader.result }));
      setError('');
    };
    reader.readAsDataURL(file);
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    setError(`✓ ${label} copiado`);
    setTimeout(() => setError(''), 1500);
  };

  const validateStep2 = () => {
    if (!formData.name.trim() || !formData.phone.trim() || !formData.mrwAddress.trim()) {
      setError('Completa todos los campos obligatorios (*)');
      return false;
    }
    if (formData.phone.replace(/\D/g, '').length < 10) {
      setError('El WhatsApp debe tener al menos 10 dígitos');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!formData.paymentCapture) { setError('Sube el capture del pago'); return; }
    setIsSubmitting(true);
    setError('');
    try {
      const response = await axios.post(`${API}/bag-order`, {
        client_name: formData.name,
        client_phone: formData.phone,
        company_name: formData.company || 'No especificado',
        mrw_address: formData.mrwAddress,
        product_name: orderData.productName,
        color: orderData.color,
        size: orderData.size,
        quantity: orderData.quantity,
        print_colors: orderData.printColors,
        unit_price_usd: orderData.unitPriceUsd,
        price_usd: orderData.priceUsd,
        price_bs: orderData.priceBs,
        tasa_bcv: tasaBcv || 0,
        payment_capture: formData.paymentCapture
      });
      setGeneratedCode(response.data.code);
      setReceiptUrl(response.data.receipt_url || '');
      setStep(4);

      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'Purchase', {
          value: orderData.priceUsd,
          currency: 'USD',
          content_name: orderData.productName,
          content_type: 'product',
          content_ids: [orderData.sizeKey],
          num_items: orderData.quantity,
          order_id: response.data.code
        });
      }
    } catch (e) {
      setError('Error al procesar. Inténtalo de nuevo.');
      devError(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const sendToOwnerWhatsApp = () => {
    const receiptFullUrl = receiptUrl ? `${BACKEND_URL}${receiptUrl}` : '(comprobante en sistema)';
    const ownerMsg = `✅ *CONFIRMACIÓN DE MI PEDIDO*
_${orderData.productName} · Impreplástico_

🎟️ *Mi código único:* ${generatedCode}

📦 *Producto:*
• ${orderData.productName}
• Cantidad: ${orderData.quantity} unidades
• Impresión: ${orderData.printColors} color${orderData.printColors > 1 ? 'es' : ''}

👤 *Mis datos:*
• Nombre: ${formData.name}
• WhatsApp: ${formData.phone}
• Empresa/Marca: ${formData.company || 'No especificado'}
• Agencia MRW: ${formData.mrwAddress}

💰 *Pago realizado:* $${orderData.priceUsd.toFixed(2)} USD / Bs. ${priceBsFormatted}
📊 Tasa BCV: ${tasaBcv}

📸 *Comprobante:*
${receiptFullUrl}

Quedo a la espera de mi propuesta digital en las próximas 48 horas. ¡Gracias!`;
    window.open(`https://wa.me/${OWNER_WHATSAPP}?text=${encodeURIComponent(ownerMsg)}`, '_blank');
  };

  const stepTitles = ['Tu Pedido', 'Tus Datos', 'Realiza el Pago', '¡Listo!'];

  return (
    <div className="fixed inset-0 bg-black/85 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="bag-purchase-modal">
      <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[92vh] overflow-y-auto shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 p-5 z-10">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-cyan-300 text-xs font-bold tracking-widest">COMPRA DIRECTA</p>
              <h3 className="text-xl md:text-2xl font-black text-white">Paso {step} de 4: {stepTitles[step - 1]}</h3>
            </div>
            <button onClick={onClose} data-testid="bag-modal-close" className="text-white hover:bg-white/20 p-2 rounded-full transition">
              <X className="w-6 h-6" />
            </button>
          </div>
          <div className="flex gap-1.5">
            {[1,2,3,4].map(s => (
              <div key={s} className={`flex-1 h-1.5 rounded-full transition-all ${s <= step ? 'bg-cyan-400' : 'bg-white/20'}`}></div>
            ))}
          </div>
        </div>

        {/* STEP 1: Resumen */}
        {step === 1 && (
          <div className="p-6 space-y-4">
            <div className="bg-slate-50 rounded-2xl p-5 border border-slate-200">
              <h4 className="text-lg font-black text-slate-800 mb-4">📦 Tu Pedido:</h4>
              <div className="space-y-3">
                <div className="flex items-center justify-between border-b border-slate-200 pb-2">
                  <div>
                    <p className="font-bold text-slate-800">{orderData.productName}</p>
                    <p className="text-xs text-slate-500">Cantidad: <strong>{orderData.quantity} unidades</strong> · Impresión: <strong>{orderData.printColors} color{orderData.printColors > 1 ? 'es' : ''}</strong></p>
                  </div>
                  <span className="text-lg font-bold text-slate-700">${orderData.priceUsd.toFixed(2)}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-600">Precio unitario</span>
                  <span className="text-slate-800 font-semibold">${orderData.unitPriceUsd.toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div className="bg-slate-900 rounded-2xl p-5 text-white">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-slate-400 text-xs uppercase tracking-wider">Total a pagar</p>
                  <p className="text-5xl font-black text-white mt-1 tabular-nums">${orderData.priceUsd.toFixed(2)}</p>
                  {tasaBcv && <p className="text-emerald-400 font-bold text-lg mt-1">Bs. {priceBsFormatted}</p>}
                </div>
                <div className="text-right">
                  <p className="text-xs text-slate-400">Tasa BCV</p>
                  <p className="text-lg font-bold text-cyan-300">{tasaBcv || '---'}</p>
                </div>
              </div>
            </div>

            <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 space-y-1 text-sm">
              <p className="font-bold text-emerald-800">✅ Incluye:</p>
              <ul className="text-emerald-700 space-y-1">
                <li>✓ Propuesta digital personalizada en &lt;48h</li>
                <li>✓ Adaptación de tu logo</li>
                <li>✓ Asesoría de impresión</li>
                <li>✓ Envío GRATIS a todo el país</li>
              </ul>
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 text-xs text-amber-800">
              ⚠️ <strong>Pago completo por adelantado.</strong> Esto activa la producción y creación de tu propuesta digital.
            </div>

            <button onClick={() => setStep(2)} data-testid="bag-step1-continue" className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-4 rounded-2xl font-black text-lg shadow-xl transition hover:scale-[1.02]">
              CONTINUAR →
            </button>
          </div>
        )}

        {/* STEP 2: Datos */}
        {step === 2 && (
          <div className="p-6 space-y-4">
            <p className="text-slate-600 text-sm bg-slate-50 border border-slate-200 rounded-lg p-3">
              👋 Llena tus datos para procesar el pedido y contactarte con la propuesta digital.
            </p>
            {[
              { key: 'name', label: 'Nombre completo *', ph: 'Tu nombre', type: 'text' },
              { key: 'phone', label: 'WhatsApp *', ph: '0414-1234567', type: 'tel' },
              { key: 'company', label: 'Nombre de tu marca / negocio', ph: 'Ej: Mi Tienda VZ', type: 'text' }
            ].map(f => (
              <div key={f.key}>
                <label className="block text-sm font-bold text-slate-700 mb-1.5">{f.label}</label>
                <input type={f.type} value={formData[f.key]} onChange={e => setFormData(p => ({...p, [f.key]: e.target.value}))} data-testid={`bag-input-${f.key}`} placeholder={f.ph} className="w-full bg-slate-50 border-2 border-slate-200 rounded-xl px-4 py-3 text-slate-800 focus:border-slate-500 focus:bg-white focus:outline-none transition" />
              </div>
            ))}
            <div>
              <label className="block text-sm font-bold text-slate-700 mb-1.5">Dirección de Agencia MRW *</label>
              <textarea value={formData.mrwAddress} onChange={e => setFormData(p => ({...p, mrwAddress: e.target.value}))} data-testid="bag-input-mrw" placeholder="Ej: MRW Centro Comercial El Recreo, Caracas" rows={2} className="w-full bg-slate-50 border-2 border-slate-200 rounded-xl px-4 py-3 text-slate-800 focus:border-slate-500 focus:bg-white focus:outline-none transition resize-none" />
              <p className="text-xs text-slate-500 mt-1">Envío GRATIS incluido.</p>
            </div>
            {error && <p className="text-red-600 text-sm font-semibold bg-red-50 p-2 rounded-lg">{error}</p>}
            <div className="flex gap-3 pt-2">
              <button onClick={() => setStep(1)} className="px-5 py-3 rounded-xl border-2 border-slate-300 text-slate-700 font-bold hover:bg-slate-50">← Atrás</button>
              <button onClick={() => { if (validateStep2()) { setError(''); setStep(3); } }} data-testid="bag-step2-continue" className="flex-1 bg-slate-900 hover:bg-slate-800 text-white py-3 rounded-xl font-black shadow-lg">
                CONTINUAR AL PAGO →
              </button>
            </div>
          </div>
        )}

        {/* STEP 3: Pago */}
        {step === 3 && (
          <div className="p-6 space-y-4">
            <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-5 text-white">
              <h4 className="text-lg font-black mb-1 flex items-center gap-2">💳 Realiza el Pago Móvil</h4>
              <p className="text-slate-300 text-sm mb-4">Toca cualquier dato para copiarlo</p>
              <div className="space-y-2 text-sm">
                {[
                  { label: 'Teléfono', value: '0414-7479327', copy: '04147479327' },
                  { label: 'Cédula', value: 'V-8030568', copy: '8030568' },
                  { label: 'Nombre', value: 'Ilba Sánchez' },
                  { label: 'Banco', value: 'Mercantil (0105)' }
                ].map(row => (
                  <button key={row.label} onClick={() => row.copy && copyToClipboard(row.copy, row.label)} className="w-full flex justify-between items-center bg-white/10 hover:bg-white/20 p-3 rounded-lg transition text-left">
                    <span className="text-slate-300">{row.label}:</span>
                    <span className="text-white font-mono font-bold">{row.value}{row.copy && <span className="ml-2 text-cyan-300 text-xs">📋</span>}</span>
                  </button>
                ))}
                <div className="flex justify-between items-center bg-cyan-400 text-slate-900 p-4 rounded-xl border-2 border-cyan-300 shadow-lg mt-3">
                  <span className="font-bold">Monto a pagar:</span>
                  <div className="text-right">
                    <p className="text-2xl font-black tabular-nums">Bs. {priceBsFormatted}</p>
                    <p className="text-xs">${orderData.priceUsd.toFixed(2)} USD · BCV {tasaBcv}</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-bold text-slate-700 mb-1.5">Capture del Pago Móvil *</label>
              <div className={`border-2 border-dashed rounded-xl p-6 text-center transition cursor-pointer ${previewImage ? 'border-emerald-500 bg-emerald-50' : 'border-slate-300 bg-slate-50 hover:bg-slate-100'}`} onClick={() => document.getElementById('bagCapture').click()} data-testid="bag-upload-area">
                {previewImage ? (
                  <div>
                    <img src={previewImage} alt="Preview" className="max-h-40 mx-auto rounded-lg mb-2 shadow-md" />
                    <p className="text-emerald-700 font-bold text-sm">✓ Comprobante cargado · Toca para cambiar</p>
                  </div>
                ) : (
                  <>
                    <Upload className="w-10 h-10 mx-auto text-slate-500 mb-2" />
                    <p className="text-slate-700 font-bold">Toca aquí para subir el capture</p>
                    <p className="text-xs text-slate-500 mt-1">JPG o PNG · Máx 5MB</p>
                  </>
                )}
                <input type="file" id="bagCapture" accept="image/*" onChange={handleFileChange} className="hidden" />
              </div>
            </div>

            {error && <p className={`text-sm font-semibold p-2 rounded-lg ${error.startsWith('✓') ? 'text-emerald-700 bg-emerald-50' : 'text-red-600 bg-red-50'}`}>{error}</p>}

            <div className="flex gap-3 pt-2">
              <button onClick={() => setStep(2)} className="px-5 py-3 rounded-xl border-2 border-slate-300 text-slate-700 font-bold hover:bg-slate-50">← Atrás</button>
              <button onClick={handleSubmit} disabled={isSubmitting || !previewImage} data-testid="bag-step3-confirm" className="flex-1 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed text-white py-3 rounded-xl font-black shadow-lg">
                {isSubmitting ? 'Procesando...' : '✓ CONFIRMAR PAGO'}
              </button>
            </div>
          </div>
        )}

        {/* STEP 4: Éxito */}
        {step === 4 && (
          <div className="p-6 text-center space-y-5" data-testid="bag-success-screen">
            <div className="w-24 h-24 mx-auto bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full flex items-center justify-center shadow-2xl animate-bounce">
              <CheckCircle className="w-14 h-14 text-white" strokeWidth={3} />
            </div>
            <div>
              <h3 className="text-3xl font-black text-slate-800 mb-2">¡Pago Recibido!</h3>
              <p className="text-slate-600">Tu pedido ha sido registrado</p>
            </div>
            <div className="bg-slate-50 rounded-2xl p-5 border-2 border-slate-300">
              <p className="text-xs font-bold text-slate-600 uppercase tracking-wider mb-2">🎟️ Tu código único e intransferible</p>
              <p className="text-3xl md:text-4xl font-black text-slate-900 tracking-wider font-mono break-all" data-testid="bag-generated-code">{generatedCode}</p>
              <button onClick={() => copyToClipboard(generatedCode, 'Código')} className="mt-3 text-sm font-bold text-slate-700 hover:text-slate-900 underline">📋 Copiar código</button>
              <p className="text-[11px] text-red-600 font-bold mt-3">⚠️ Este código es exclusivo para ti. No puede ser compartido ni transferido.</p>
            </div>
            <div className="bg-emerald-50 rounded-2xl p-5 border-2 border-emerald-500">
              <p className="font-black text-emerald-800 text-lg mb-1">📲 Último paso</p>
              <p className="text-sm text-slate-700 mb-4">Envíanos tu confirmación por WhatsApp para activar tu propuesta digital en &lt;48h.</p>
              <button onClick={sendToOwnerWhatsApp} data-testid="bag-send-whatsapp" className="w-full bg-emerald-500 hover:bg-emerald-600 text-white py-4 rounded-2xl font-black text-lg shadow-xl flex items-center justify-center gap-3 transition hover:scale-[1.02]">
                <MessageCircle className="w-6 h-6" /> ENVIAR POR WHATSAPP
              </button>
            </div>
            <div className="text-left bg-slate-50 rounded-xl p-4 text-sm space-y-1">
              <p className="font-bold text-slate-700 mb-2">📋 Resumen:</p>
              <p className="text-slate-600">• <strong>Producto:</strong> {orderData.productName}</p>
              <p className="text-slate-600">• <strong>Cantidad:</strong> {orderData.quantity} unidades</p>
              <p className="text-slate-600">• <strong>Pagado:</strong> ${orderData.priceUsd.toFixed(2)} USD (Bs. {priceBsFormatted})</p>
              <p className="text-slate-600">• <strong>Cliente:</strong> {formData.name}</p>
            </div>
            <button onClick={onClose} data-testid="bag-success-close" className="w-full bg-slate-100 hover:bg-slate-200 text-slate-700 py-3 rounded-2xl font-bold">Cerrar</button>
          </div>
        )}
      </div>
    </div>
  );
}


// =============================================================
// CART: multi-item shopping cart for bags
// =============================================================
function CartDrawer({ isOpen, onClose, items, tasaBcv, onRemove, onCheckout }) {
  if (!isOpen) return null;
  const totalUnits = items.reduce((s, i) => s + i.quantity, 0);
  const totalUsd = +items.reduce((s, i) => s + i.subtotalUsd, 0).toFixed(2);
  const totalBs = tasaBcv ? +(totalUsd * tasaBcv).toFixed(2) : 0;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex justify-end" onClick={onClose} data-testid="cart-drawer">
      <div onClick={(e) => e.stopPropagation()} className="bg-white w-full max-w-md h-full overflow-y-auto shadow-2xl flex flex-col">
        <div className="sticky top-0 bg-slate-900 text-white p-5 flex items-center justify-between">
          <div>
            <p className="text-xs text-slate-400 uppercase font-bold tracking-widest">Tu carrito</p>
            <h3 className="text-xl font-black">🛒 {items.length} {items.length === 1 ? 'producto' : 'productos'}</h3>
          </div>
          <button onClick={onClose} data-testid="cart-drawer-close" className="hover:bg-white/10 p-2 rounded-full"><X className="w-5 h-5" /></button>
        </div>

        <div className="flex-1 p-4 space-y-3">
          {items.length === 0 && (
            <div className="text-center py-12">
              <ShoppingBag className="w-16 h-16 mx-auto text-slate-300 mb-3" />
              <p className="text-slate-500 font-semibold">Tu carrito está vacío</p>
              <p className="text-xs text-slate-400 mt-1">Agrega bolsas para verlas aquí</p>
            </div>
          )}
          {items.map((item, idx) => (
            <div key={`${item.sizeKey}-${item.printColors}`} className="bg-slate-50 rounded-xl p-3 flex items-center gap-3">
              <div className="w-14 h-14 bg-cyan-100 rounded-lg flex items-center justify-center text-2xl flex-shrink-0">📦</div>
              <div className="flex-1 min-w-0">
                <p className="font-black text-slate-800 text-sm truncate">{item.productName}</p>
                <p className="text-xs text-slate-500">{item.quantity} uds · {item.printColors} color{item.printColors > 1 ? 'es' : ''} · ${item.unitPriceUsd.toFixed(2)}/u</p>
                <p className="text-sm font-black text-slate-900 mt-0.5 tabular-nums">${item.subtotalUsd.toFixed(2)}</p>
              </div>
              <button onClick={() => onRemove(idx)} data-testid={`cart-remove-${idx}`} className="text-red-500 hover:text-red-700 p-1"><X className="w-4 h-4" /></button>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="sticky bottom-0 bg-white border-t border-slate-200 p-4 space-y-3">
            <div className="bg-slate-900 rounded-xl p-3 text-white">
              <div className="flex justify-between text-xs"><span className="text-slate-300">Total unidades:</span><span className="font-bold tabular-nums">{totalUnits}</span></div>
              <div className="flex justify-between items-baseline mt-1">
                <span className="text-slate-300 text-sm font-bold">Total:</span>
                <div className="text-right">
                  <p className="text-2xl font-black tabular-nums" data-testid="cart-total-usd">${totalUsd.toFixed(2)}</p>
                  {tasaBcv && <p className="text-xs text-emerald-400">Bs. {totalBs.toFixed(2)}</p>}
                </div>
              </div>
            </div>
            <button onClick={onCheckout} data-testid="cart-checkout-btn" className="w-full bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white py-3.5 rounded-xl font-black shadow-lg">
              PROCEDER AL PAGO →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function CartCheckoutModal({ isOpen, onClose, items, tasaBcv, onSuccess }) {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ name: '', phone: '', company: '', mrwAddress: '', paymentCapture: null });
  const [previewImage, setPreviewImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [generatedCode, setGeneratedCode] = useState('');
  const [receiptUrl, setReceiptUrl] = useState('');
  const [error, setError] = useState('');

  const totalUnits = items.reduce((s, i) => s + i.quantity, 0);
  const totalUsd = +items.reduce((s, i) => s + i.subtotalUsd, 0).toFixed(2);
  const totalBs = tasaBcv ? +(totalUsd * tasaBcv).toFixed(2) : 0;

  useEffect(() => {
    if (!isOpen) {
      setStep(1);
      setFormData({ name: '', phone: '', company: '', mrwAddress: '', paymentCapture: null });
      setPreviewImage(null);
      setGeneratedCode('');
      setReceiptUrl('');
      setError('');
    } else if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout', { content_name: 'Carrito Bolsas', value: totalUsd, currency: 'USD', num_items: totalUnits });
    }
  }, [isOpen]); // eslint-disable-line

  if (!isOpen || items.length === 0) return null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { setError('La imagen debe ser menor a 5MB'); return; }
    const reader = new FileReader();
    reader.onloadend = () => { setPreviewImage(reader.result); setFormData(prev => ({ ...prev, paymentCapture: reader.result })); setError(''); };
    reader.readAsDataURL(file);
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    setError(`✓ ${label} copiado`);
    setTimeout(() => setError(''), 1500);
  };

  const validateStep2 = () => {
    if (!formData.name.trim() || !formData.phone.trim() || !formData.mrwAddress.trim()) {
      setError('Completa todos los campos obligatorios (*)'); return false;
    }
    if (formData.phone.replace(/\D/g, '').length < 10) { setError('WhatsApp inválido'); return false; }
    return true;
  };

  const handleSubmit = async () => {
    if (!formData.paymentCapture) { setError('Sube el comprobante'); return; }
    setIsSubmitting(true); setError('');
    try {
      const payload = {
        client_name: formData.name,
        client_phone: formData.phone,
        company_name: formData.company || 'No especificado',
        mrw_address: formData.mrwAddress,
        items: items.map(i => ({
          product_name: i.productName,
          size_key: i.sizeKey,
          color: i.color,
          size: i.size,
          quantity: i.quantity,
          print_colors: i.printColors,
          unit_price_usd: i.unitPriceUsd,
          subtotal_usd: i.subtotalUsd
        })),
        total_units: totalUnits,
        price_usd: totalUsd,
        price_bs: totalBs,
        tasa_bcv: tasaBcv || 0,
        payment_capture: formData.paymentCapture
      };
      const response = await axios.post(`${API}/cart-order`, payload);
      setGeneratedCode(response.data.code);
      setReceiptUrl(response.data.receipt_url || '');
      setStep(4);
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'Purchase', { value: totalUsd, currency: 'USD', content_name: 'Carrito Bolsas', num_items: totalUnits, order_id: response.data.code });
      }
    } catch (e) {
      setError('Error al procesar el pedido. Inténtalo de nuevo.');
      devError(e);
    } finally { setIsSubmitting(false); }
  };

  const sendToOwnerWhatsApp = () => {
    const receiptFullUrl = receiptUrl ? `${BACKEND_URL}${receiptUrl}` : '(comprobante en sistema)';
    const itemsList = items.map(i => `• ${i.quantity} × ${i.productName} · ${i.printColors} color${i.printColors > 1 ? 'es' : ''} · $${i.subtotalUsd.toFixed(2)}`).join('\n');
    const msg = `🛒 *CONFIRMACIÓN DE MI PEDIDO*
_Carrito de Bolsas · Impreplástico_

🎟️ *Mi código único:* ${generatedCode}

👤 *Mis datos:*
• Nombre: ${formData.name}
• WhatsApp: ${formData.phone}
• Empresa/Marca: ${formData.company || 'No especificado'}
• Agencia MRW: ${formData.mrwAddress}

📦 *Productos (${totalUnits} unidades):*
${itemsList}

💰 *Pago realizado:* $${totalUsd.toFixed(2)} USD / Bs. ${totalBs.toFixed(2)}
📊 Tasa BCV: ${tasaBcv}

📸 *Comprobante:*
${receiptFullUrl}

Quedo a la espera de mi propuesta digital en las próximas 48 horas. ¡Gracias!`;
    window.open(`https://wa.me/${OWNER_WHATSAPP}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const stepTitles = ['Tu Carrito', 'Tus Datos', 'Realiza el Pago', '¡Listo!'];

  return (
    <div className="fixed inset-0 bg-black/85 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="cart-checkout-modal">
      <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[92vh] overflow-y-auto shadow-2xl">
        <div className="sticky top-0 bg-gradient-to-r from-slate-900 via-teal-800 to-cyan-700 p-5 z-10">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-white/80 text-xs font-bold tracking-widest">🛒 CARRITO MULTI-BOLSA</p>
              <h3 className="text-2xl font-black text-white">Paso {step} de 4: {stepTitles[step - 1]}</h3>
            </div>
            <button onClick={onClose} data-testid="cart-modal-close" className="text-white hover:bg-white/20 p-2 rounded-full"><X className="w-6 h-6" /></button>
          </div>
          <div className="flex gap-1.5">
            {[1, 2, 3, 4].map(s => <div key={s} className={`flex-1 h-1.5 rounded-full ${s <= step ? 'bg-yellow-300' : 'bg-white/20'}`}></div>)}
          </div>
        </div>

        {/* STEP 1: Review items */}
        {step === 1 && (
          <div className="p-6 space-y-4">
            <div className="bg-gradient-to-br from-teal-50 via-cyan-50 to-emerald-50 rounded-2xl p-4 border-2 border-cyan-200">
              <h4 className="text-lg font-black text-gray-800 mb-3">📦 Resumen del pedido</h4>
              <div className="space-y-2">
                {items.map((item, idx) => (
                  <div key={`${item.sizeKey}-${item.printColors}`} className="flex justify-between bg-white p-3 rounded-lg shadow-sm">
                    <div>
                      <p className="font-black text-sm text-gray-800">{item.productName}</p>
                      <p className="text-xs text-gray-500">{item.quantity} uds · {item.printColors} color{item.printColors > 1 ? 'es' : ''} · ${item.unitPriceUsd.toFixed(2)}/u</p>
                    </div>
                    <span className="font-black text-slate-900 tabular-nums">${item.subtotalUsd.toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-slate-900 rounded-2xl p-5 text-white">
              <div className="flex justify-between text-xs mb-2"><span className="text-slate-300">Total unidades:</span><span className="font-bold tabular-nums">{totalUnits}</span></div>
              <div className="flex justify-between items-baseline">
                <span className="text-slate-300 font-bold">Total a pagar:</span>
                <div className="text-right">
                  <p className="text-4xl font-black tabular-nums">${totalUsd.toFixed(2)}</p>
                  {tasaBcv && <p className="text-sm text-emerald-400">Bs. {totalBs.toFixed(2)}</p>}
                </div>
              </div>
            </div>
            <div className="bg-red-50 border-2 border-red-300 rounded-xl p-3 text-xs text-gray-700 space-y-1">
              <p><strong>⚠️ Importante:</strong></p>
              <p>• Pago completo por adelantado.</p>
              <p>• Envío NO incluido, se cotiza aparte al confirmar producción.</p>
              <p>• Incluye propuesta digital + adaptación de logo.</p>
            </div>
            <button onClick={() => setStep(2)} data-testid="cart-step1-continue" className="w-full bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white py-4 rounded-2xl font-black text-lg shadow-xl">
              CONTINUAR →
            </button>
          </div>
        )}

        {/* STEP 2: Datos */}
        {step === 2 && (
          <div className="p-6 space-y-4">
            <p className="text-gray-600 text-sm bg-blue-50 border border-blue-200 rounded-lg p-3">👋 Llena tus datos. Te contactaremos por WhatsApp con tu propuesta digital.</p>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">Nombre completo *</label>
              <input type="text" value={formData.name} onChange={(e) => setFormData(p => ({ ...p, name: e.target.value }))} data-testid="cart-input-name" placeholder="Tu nombre" className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-teal-500 focus:bg-white focus:outline-none transition" />
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">WhatsApp *</label>
              <input type="tel" value={formData.phone} onChange={(e) => setFormData(p => ({ ...p, phone: e.target.value }))} data-testid="cart-input-phone" placeholder="0414-1234567" className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-teal-500 focus:bg-white focus:outline-none transition" />
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">Nombre de tu marca / negocio</label>
              <input type="text" value={formData.company} onChange={(e) => setFormData(p => ({ ...p, company: e.target.value }))} data-testid="cart-input-company" placeholder="Ej: Mi Tienda VZ" className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-teal-500 focus:bg-white focus:outline-none transition" />
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">Dirección de Agencia MRW *</label>
              <textarea value={formData.mrwAddress} onChange={(e) => setFormData(p => ({ ...p, mrwAddress: e.target.value }))} data-testid="cart-input-mrw" rows={2} placeholder="Ej: MRW Centro Comercial El Recreo, Caracas" className="w-full bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 focus:border-teal-500 focus:bg-white focus:outline-none transition resize-none" />
              <p className="text-xs text-gray-500 mt-1">El envío se cotiza aparte al confirmar producción.</p>
            </div>
            {error && <p className="text-red-600 text-sm font-semibold bg-red-50 p-2 rounded-lg">{error}</p>}
            <div className="flex gap-3 pt-2">
              <button onClick={() => setStep(1)} className="px-5 py-3 rounded-xl border-2 border-gray-300 text-gray-700 font-bold hover:bg-gray-50">← Atrás</button>
              <button onClick={() => { if (validateStep2()) { setError(''); setStep(3); } }} data-testid="cart-step2-continue" className="flex-1 bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white py-3 rounded-xl font-black shadow-lg">CONTINUAR AL PAGO →</button>
            </div>
          </div>
        )}

        {/* STEP 3: Pago */}
        {step === 3 && (
          <div className="p-6 space-y-4">
            <div className="bg-gradient-to-br from-blue-900 to-indigo-900 rounded-2xl p-5 text-white">
              <h4 className="text-lg font-black mb-1 flex items-center gap-2">💳 Realiza el Pago Móvil</h4>
              <p className="text-blue-100 text-sm mb-4">Toca cualquier dato para copiarlo</p>
              <div className="space-y-2 text-sm">
                {[
                  { label: 'Teléfono', value: '0414-7479327', copy: '04147479327' },
                  { label: 'Cédula', value: 'V-8030568', copy: '8030568' },
                  { label: 'Nombre', value: 'Ilba Sánchez' },
                  { label: 'Banco', value: 'Mercantil (0105)' }
                ].map((row) => (
                  <button key={row.label} onClick={() => row.copy && copyToClipboard(row.copy, row.label)} className="w-full flex justify-between items-center bg-white/10 hover:bg-white/20 p-3 rounded-lg text-left">
                    <span className="text-blue-200">{row.label}:</span>
                    <span className="text-white font-mono font-bold">{row.value}{row.copy && <span className="ml-2 text-cyan-300 text-xs">📋</span>}</span>
                  </button>
                ))}
                <div className="flex justify-between items-center bg-yellow-400 text-black p-4 rounded-xl border-2 border-yellow-300 shadow-lg mt-3">
                  <span className="font-bold">Monto a pagar:</span>
                  <div className="text-right">
                    <p className="text-2xl font-black">Bs. {totalBs.toFixed(2)}</p>
                    <p className="text-xs">${totalUsd.toFixed(2)} USD · BCV {tasaBcv}</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">Capture del Pago Móvil *</label>
              <div className={`border-2 border-dashed rounded-xl p-6 text-center cursor-pointer ${previewImage ? 'border-green-500 bg-green-50' : 'border-teal-300 bg-teal-50 hover:bg-teal-100'}`} onClick={() => document.getElementById('cartCapture').click()} data-testid="cart-upload-area">
                {previewImage ? (
                  <div>
                    <img src={previewImage} alt="Preview" className="max-h-40 mx-auto rounded-lg mb-2 shadow-md" />
                    <p className="text-green-700 font-bold text-sm">✓ Comprobante cargado · Toca para cambiar</p>
                  </div>
                ) : (
                  <>
                    <Upload className="w-10 h-10 mx-auto text-teal-500 mb-2" />
                    <p className="text-teal-700 font-bold">Toca aquí para subir el capture</p>
                    <p className="text-xs text-gray-500 mt-1">JPG o PNG · Máx 5MB</p>
                  </>
                )}
                <input type="file" id="cartCapture" accept="image/*" onChange={handleFileChange} className="hidden" />
              </div>
            </div>
            {error && <p className={`text-sm font-semibold p-2 rounded-lg ${error.startsWith('✓') ? 'text-green-700 bg-green-50' : 'text-red-600 bg-red-50'}`}>{error}</p>}
            <div className="flex gap-3 pt-2">
              <button onClick={() => setStep(2)} className="px-5 py-3 rounded-xl border-2 border-gray-300 text-gray-700 font-bold hover:bg-gray-50">← Atrás</button>
              <button onClick={handleSubmit} disabled={isSubmitting || !previewImage} data-testid="cart-step3-confirm" className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 disabled:opacity-50 text-white py-3 rounded-xl font-black shadow-lg">
                {isSubmitting ? 'Procesando...' : '✓ CONFIRMAR PAGO'}
              </button>
            </div>
          </div>
        )}

        {/* STEP 4: Success */}
        {step === 4 && (
          <div className="p-6 text-center space-y-5" data-testid="cart-success-screen">
            <div className="w-24 h-24 mx-auto bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-2xl animate-bounce">
              <CheckCircle className="w-14 h-14 text-white" strokeWidth={3} />
            </div>
            <div>
              <h3 className="text-3xl font-black text-gray-800 mb-2">¡Pago Recibido!</h3>
              <p className="text-gray-600">Tu pedido ha sido registrado</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 via-cyan-50 to-emerald-50 rounded-2xl p-5 border-2 border-cyan-300">
              <p className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-2">🎟️ Tu código único</p>
              <p className="text-3xl md:text-4xl font-black bg-gradient-to-r from-teal-700 to-cyan-700 bg-clip-text text-transparent tracking-wider font-mono break-all" data-testid="cart-generated-code">{generatedCode}</p>
              <button onClick={() => copyToClipboard(generatedCode, 'Código')} className="mt-3 text-sm font-bold text-teal-700 hover:text-teal-900 underline">📋 Copiar código</button>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-5 border-2 border-green-500 shadow-lg">
              <p className="font-black text-green-800 text-lg mb-1">📲 Último paso</p>
              <p className="text-sm text-gray-700 mb-4">Envíanos tu código y comprobante por WhatsApp.</p>
              <button onClick={sendToOwnerWhatsApp} data-testid="cart-send-whatsapp" className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 rounded-2xl font-black text-lg shadow-xl flex items-center justify-center gap-3">
                <MessageCircle className="w-6 h-6" /> ENVIAR POR WHATSAPP
              </button>
            </div>
            <button onClick={() => { onSuccess && onSuccess(); onClose(); }} data-testid="cart-success-close" className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-2xl font-bold">Cerrar</button>
          </div>
        )}
      </div>
    </div>
  );
}


function ComboCountdown({ deadline }) {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const update = () => {
      const diff = deadline.getTime() - Date.now();
      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60)
      });
    };
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  const cell = (val, label) => (
    <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-3 py-2 min-w-[60px] text-center">
      <p className="text-2xl md:text-3xl font-black text-white leading-none tabular-nums">{String(val).padStart(2, '0')}</p>
      <p className="text-[9px] uppercase text-white/70 tracking-wider mt-1">{label}</p>
    </div>
  );

  return (
    <div className="flex items-center justify-center gap-2 md:gap-3">
      {cell(timeLeft.days, 'Días')}
      {cell(timeLeft.hours, 'Horas')}
      {cell(timeLeft.minutes, 'Min')}
      {cell(timeLeft.seconds, 'Seg')}
    </div>
  );
}

// Size Module Component ACTUALIZADO con fuelle y medidas
function SizeModule({ sizeKey, data, tasaBcv, onOpenChat, onBuy, onAddToCart }) {
  const [colors, setColors] = useState(1);
  const [quantity, setQuantity] = useState(100);
  const [rotate, setRotate] = useState(0);
  const maxColors = Object.keys(data.prices).length;

  // Animación de rotación 360 SOLO para bolsas negras
  useEffect(() => {
    if (data.color === 'black') {
      const interval = setInterval(() => {
        setRotate(prev => (prev + 1) % 360);
      }, 50);
      return () => clearInterval(interval);
    }
  }, [data.color]);

  // Calcular precio con descuento
  let basePrice = data.prices[Math.min(colors, maxColors)];
  let unitPrice = basePrice;
  if (data.discount > 0) {
    unitPrice = basePrice * (1 - data.discount / 100);
  }

  // Descuento por volumen (bolsas negras): 500+ = -15%, 1000+ = -25%
  let volumeDiscountPct = 0;
  if (data.volumeDiscount) {
    if (quantity >= 1000) volumeDiscountPct = 25;
    else if (quantity >= 500) volumeDiscountPct = 15;
    if (volumeDiscountPct > 0) {
      unitPrice = unitPrice * (1 - volumeDiscountPct / 100);
    }
  }

  const totalPriceUsd = (quantity * unitPrice).toFixed(2);
  const totalPriceBs = tasaBcv ? (quantity * unitPrice * tasaBcv).toFixed(2) : '---';

  // Imagen de la bolsa según color y si tiene fuelle
  const getBagImage = () => {
    if (data.color === 'black') return BAG_IMAGE_BLACK;
    if (data.color === 'transparent') return BAG_IMAGE_TRANSPARENT;
    if (data.hasGusset) return BAG_IMAGE_WHITE_FUELLE;
    return BAG_IMAGE_WHITE_BOUTIQUE;
  };

  return (
    <div className="bg-gradient-to-br from-white to-gray-50 text-gray-800 rounded-2xl shadow-2xl overflow-hidden border border-gray-200">
      {/* Header con badges */}
      <div className={`p-4 ${data.color === 'black' ? 'bg-gradient-to-r from-gray-700 to-gray-900' : 'bg-gradient-to-r from-cyan-500 via-magenta-500 to-yellow-500'}`}>
        <div className="flex justify-between items-start">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <h3 className="text-2xl font-black text-white">{data.name}</h3>
              {data.isNew && (
                <span className="bg-yellow-400 text-black text-xs font-black px-2 py-0.5 rounded-full animate-pulse">
                  ¡NUEVO!
                </span>
              )}
            </div>
            <p className="text-white/80 text-sm">{data.subtitle}</p>
          </div>
          {data.discount > 0 ? (
            <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-black">
              -{data.discount}%
            </div>
          ) : data.shippingIncluded ? (
            <div className="bg-amber-400 text-black px-3 py-1 rounded-full text-xs font-black flex items-center gap-1 shadow-lg" data-testid={`shipping-badge-${sizeKey}`}>
              <Truck className="w-3.5 h-3.5" /> ENVÍO INCLUIDO
            </div>
          ) : null}
        </div>
      </div>

      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Lado izquierdo - Imagen de bolsa con medidas */}
          <div className="relative">
            {/* Contenedor de imagen con flechas de medidas */}
            <div className={`relative rounded-xl p-4 h-72 flex items-center justify-center ${data.color === 'black' ? 'bg-gradient-to-br from-gray-100 to-gray-300' : 'bg-gradient-to-br from-gray-100 to-gray-200'}`}>
              
              {/* Wrapper compacto: imagen + flechas pegadas a la bolsa */}
              <div className="relative inline-block">
                <img 
                  src={getBagImage()}
                  alt={`Bolsa ${data.colorName}`}
                  className="h-56 w-auto object-contain drop-shadow-2xl block"
                  style={data.color === 'black' ? { transform: `rotateY(${rotate}deg)`, transition: 'transform 0.1s' } : {}}
                />

                {data.color === 'white' && data.hasGusset ? (
                  /* Imagen ya tiene flechas A/B/C: solo overlay de números */
                  <>
                    {/* Medida ALTO (A) - cerca de la flecha A en la izquierda */}
                    <span className="absolute font-black text-cyan-700 bg-white px-2 py-0.5 rounded-md shadow-lg border-2 border-cyan-400 whitespace-nowrap text-xs" style={{ left: '4%', top: '50%', transform: 'translateY(-50%)' }}>
                      {data.height}
                    </span>
                    {/* Medida ANCHO (B) - cerca de la flecha B abajo */}
                    <span className="absolute font-black text-pink-700 bg-white px-2 py-0.5 rounded-md shadow-lg border-2 border-pink-400 whitespace-nowrap text-xs" style={{ left: '32%', bottom: '4%' }}>
                      {data.width}
                    </span>
                    {/* Medida FUELLE (C) - cerca de la flecha C diagonal abajo-derecha */}
                    <span className="absolute font-black text-yellow-700 bg-white px-2 py-0.5 rounded-md shadow-lg border-2 border-yellow-400 whitespace-nowrap text-xs" style={{ right: '0%', bottom: '0%' }}>
                      {data.gusset ? data.gusset.replace('+ ', '').replace(' Fuelle', '') : '5cm'}
                    </span>
                  </>
                ) : (
                  /* Otras bolsas (S blanca, negra, transparente): flechas CSS personalizadas */
                  <>
                    {/* Flecha ALTO (izquierda) - Cyan */}
                    <div className="absolute -left-7 top-2 bottom-2 flex items-center">
                      <div className="relative w-3 h-full flex flex-col items-center">
                        <div className="absolute top-0 w-0 h-0 border-l-[5px] border-l-transparent border-b-[8px] border-b-cyan-500 border-r-[5px] border-r-transparent"></div>
                        <div className="flex-1 w-0.5 bg-cyan-500 my-1.5"></div>
                        <div className="absolute bottom-0 w-0 h-0 border-l-[5px] border-l-transparent border-t-[8px] border-t-cyan-500 border-r-[5px] border-r-transparent"></div>
                      </div>
                      <span className="absolute -left-3 top-1/2 -translate-y-1/2 -rotate-90 origin-center text-[10px] font-bold text-cyan-700 bg-white px-1.5 py-0.5 rounded shadow-md border border-cyan-300 whitespace-nowrap">
                        {data.height}
                      </span>
                    </div>

                    {/* Flecha ANCHO (abajo) - Magenta */}
                    <div className="absolute -bottom-7 left-2 right-2 flex items-center">
                      <div className="relative w-full h-3 flex items-center">
                        <div className="absolute left-0 w-0 h-0 border-t-[5px] border-t-transparent border-r-[8px] border-r-pink-500 border-b-[5px] border-b-transparent"></div>
                        <div className="flex-1 h-0.5 bg-pink-500 mx-1.5"></div>
                        <div className="absolute right-0 w-0 h-0 border-t-[5px] border-t-transparent border-l-[8px] border-l-pink-500 border-b-[5px] border-b-transparent"></div>
                      </div>
                      <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[10px] font-bold text-pink-700 bg-white px-1.5 py-0.5 rounded shadow-md border border-pink-300 whitespace-nowrap">
                        {data.width}
                      </span>
                    </div>
                  </>
                )}
              </div>

              {/* Badge fuelle */}
              {data.hasGusset && (
                <div className="absolute top-2 left-2 bg-cyan-500 text-white text-xs font-bold px-2 py-1 rounded-full flex items-center gap-1 shadow-md">
                  <span>✓</span> Con Fuelle
                </div>
              )}
              
              {/* Badge 360 solo para negras */}
              {data.color === 'black' && (
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded-full shadow-md">
                  Vista 360°
                </div>
              )}
            </div>

            {/* Barra de medidas */}
            <div className="mt-4 p-3 rounded-lg bg-gray-100">
              <p className="text-xs font-semibold mb-2 text-gray-500">MEDIDAS</p>
              <div className="grid grid-cols-3 gap-2 text-center">
                <div className="p-2 rounded bg-white border-2 border-cyan-400">
                  <p className="text-xs text-gray-500">Ancho</p>
                  <p className="font-bold text-cyan-500">{data.width}</p>
                </div>
                <div className="p-2 rounded bg-white border-2 border-magenta-400">
                  <p className="text-xs text-gray-500">Alto</p>
                  <p className="font-bold text-magenta-500">{data.height}</p>
                </div>
                <div className="p-2 rounded bg-white border-2 border-yellow-400">
                  <p className="text-xs text-gray-500">Fuelle</p>
                  <p className="font-bold text-yellow-500">{data.hasGusset ? data.gusset.replace('+ ', '').replace(/\s*Fuelle\s*/i, '').trim() : '-'}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Lado derecho - Opciones y precios */}
          <div className="space-y-4">
            {/* Colores de impresión */}
            <div>
              <label className="block text-sm font-semibold mb-2 text-gray-700">
                Colores de impresión
              </label>
              <div className="grid grid-cols-3 gap-2">
                {[1, 2, 3].slice(0, maxColors).map((num) => (
                  <button
                    key={num}
                    onClick={() => setColors(num)}
                    data-testid={`print-colors-${sizeKey}-${num}`}
                    className={`py-2 px-3 rounded-lg font-semibold text-sm transition-all ${
                      colors === num
                        ? 'bg-gradient-to-r from-cyan-500 to-magenta-500 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {num} Color{num > 1 ? 'es' : ''}
                  </button>
                ))}
              </div>
            </div>

            {/* Cantidad */}
            <div>
              <label className="block text-sm font-semibold mb-2 text-gray-700">
                Cantidad (mín. 100)
              </label>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setQuantity(prev => Math.max(100, prev - 50))}
                  className="w-10 h-10 rounded-lg font-bold transition bg-gray-200 hover:bg-gray-300"
                >-</button>
                <input
                  type="text"
                  value={quantity}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, '');
                    setQuantity(val === '' ? 100 : Math.max(100, parseInt(val, 10)));
                  }}
                  className="flex-1 px-3 py-2 rounded-lg text-center font-semibold bg-white border-gray-200 border-2 focus:border-cyan-500 focus:outline-none"
                />
                <button
                  onClick={() => setQuantity(prev => prev + 50)}
                  className="w-10 h-10 bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg font-bold transition"
                >+</button>
              </div>
            </div>

            {/* Precios — Corporate, alta legibilidad */}
            <div className="p-4 rounded-xl bg-slate-50 border border-slate-200">
              <div className="flex justify-between items-center mb-2">
                <span className="text-slate-600 text-sm">Precio/unidad:</span>
                <span className="text-base font-bold text-slate-800">${unitPrice.toFixed(2)}</span>
              </div>
              {data.volumeDiscount && volumeDiscountPct > 0 && (
                <div className="flex justify-between items-center bg-emerald-50 border border-emerald-300 rounded-lg px-2 py-1 mb-1" data-testid={`volume-discount-${sizeKey}`}>
                  <span className="text-emerald-700 text-xs font-bold">🎉 Dto. por volumen aplicado:</span>
                  <span className="text-emerald-700 text-xs font-black">-{volumeDiscountPct}%</span>
                </div>
              )}
              <div className="flex justify-between items-center pt-3 border-t border-slate-200">
                <span className="font-semibold text-slate-700">Total USD:</span>
                <span className="text-3xl font-black text-slate-900 tabular-nums" data-testid={`total-usd-${sizeKey}`}>
                  ${totalPriceUsd}
                </span>
              </div>
              <div className="flex justify-between items-center mt-1">
                <span className="text-sm text-slate-500">Total Bs (BCV):</span>
                <span className="text-lg font-bold text-emerald-600 tabular-nums">Bs. {totalPriceBs}</span>
              </div>
              {data.volumeDiscount && (
                <div className="mt-2 pt-2 border-t border-slate-200 text-[10px] text-slate-500 flex items-center justify-between" data-testid={`volume-tiers-${sizeKey}`}>
                  <span className={quantity >= 500 && quantity < 1000 ? 'text-emerald-600 font-bold' : ''}>500u = -15%</span>
                  <span className={quantity >= 1000 ? 'text-emerald-600 font-bold' : ''}>1000u = -25%</span>
                </div>
              )}
            </div>

            {/* Info adicional */}
            <div className="space-y-1 text-xs">
              <div className="flex items-center gap-2 text-emerald-600">
                <CheckCircle className="w-3 h-3" /> {data.shippingIncluded ? 'Envío INCLUIDO en el precio' : 'Envío GRATIS a todo el país'}
              </div>
              <div className="flex items-center gap-2 text-emerald-600">
                <CheckCircle className="w-3 h-3" /> Pago único · Propuesta incluida
              </div>
            </div>

            {/* CTA PRIMARIO: Comprar Ahora (pago completo) */}
            <button
              onClick={() => onBuy && onBuy({
                sizeKey,
                productName: `Bolsa ${data.name} ${data.colorName}${data.hasGusset ? ' con fuelle' : ''}`,
                color: data.color,
                size: data.name,
                quantity,
                printColors: colors,
                unitPriceUsd: unitPrice,
                priceUsd: parseFloat(totalPriceUsd),
                priceBs: parseFloat(totalPriceBs !== '---' ? totalPriceBs : 0),
                tasaBcv
              })}
              data-testid={`comprar-ahora-${sizeKey}`}
              className="relative w-full bg-slate-900 hover:bg-slate-800 text-white font-black py-4 px-4 rounded-xl transition-all flex items-center justify-center gap-2 shadow-xl hover:shadow-2xl hover:scale-[1.02] group overflow-hidden"
            >
              <ShoppingBag className="w-5 h-5" />
              <span>COMPRAR AHORA</span>
              {/* Shine sweep */}
              <div className="absolute inset-0 pointer-events-none overflow-hidden">
                <div
                  className="absolute top-0 -left-1/2 w-1/3 h-full"
                  style={{
                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent)',
                    animation: 'btnShine 4s ease-in-out infinite'
                  }}
                ></div>
              </div>
            </button>

            {/* CTA SECUNDARIO: Añadir al carrito */}
            <button
              onClick={() => onAddToCart && onAddToCart({
                sizeKey,
                productName: `Bolsa ${data.name} ${data.colorName}${data.hasGusset ? ' con fuelle' : ''}`,
                color: data.color,
                size: data.name,
                quantity,
                printColors: colors,
                unitPriceUsd: unitPrice,
                subtotalUsd: parseFloat(totalPriceUsd),
              })}
              data-testid={`add-to-cart-${sizeKey}`}
              className="w-full bg-white hover:bg-slate-50 text-slate-900 font-black py-3 px-4 rounded-xl border-2 border-slate-900 transition flex items-center justify-center gap-2 hover:shadow-lg"
            >
              <ShoppingCart className="w-5 h-5" />
              <span>AÑADIR AL CARRITO</span>
            </button>

            {/* Botón Calcula tu tamaño ideal */}
            <button
              onClick={() => onOpenChat && onOpenChat()}
              data-testid={`calcula-tamano-${sizeKey}`}
              className="w-full bg-transparent hover:bg-slate-50 text-slate-600 font-semibold py-2 px-4 rounded-xl transition flex items-center justify-center gap-2 text-xs"
            >
              <span>📐</span>
              Calcula tu tamaño ideal
            </button>
          </div>
        </div>

        {/* Info del producto */}
        <p className="text-sm mt-4 text-slate-600">
          {data.examples}
        </p>
      </div>
    </div>
  );
}

// FAQ Item Component
function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full py-4 flex justify-between items-center text-left hover:text-cyan-600 transition"
      >
        <span className="font-semibold text-gray-800">{question}</span>
        <ChevronDown className={`w-5 h-5 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="pb-4 text-gray-600">
          {answer}
        </div>
      )}
    </div>
  );
}

// Chatbot IA
function AIChatbot({ isOpen, onClose }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [sessionId] = useState(() => `session-${Date.now()}`);

  const sendMessage = async () => {
    if (!input.trim() || loading) return;

    const userMsg = input.trim();
    setMessages((prev) => [...prev, { type: 'user', text: userMsg }]);
    setInput('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/ai-advisor`, {
        message: userMsg,
        session_id: sessionId
      });
      
      setMessages((prev) => [
        ...prev,
        { type: 'ai', text: response.data.response }
      ]);
    } catch (error) {
      devError('Error sending message:', error);
      setMessages((prev) => [
        ...prev,
        { type: 'ai', text: 'Lo siento, hubo un error. Por favor intenta de nuevo.' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-end md:items-center justify-center p-0 md:p-4">
      <div className="bg-white w-full md:max-w-2xl md:rounded-2xl shadow-2xl flex flex-col h-[100vh] md:h-[600px]">
        <div className="bg-magenta-500 text-white p-4 flex items-center justify-between md:rounded-t-2xl">
          <div className="flex items-center gap-3">
            <Package className="w-6 h-6" />
            <div>
              <h3 className="font-bold text-lg">Asesor Virtual</h3>
              <p className="text-sm text-magenta-100">Impreplástico</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-lg transition"
            data-testid="close-chat-btn"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-gray-50">
          {messages.length === 0 && (
            <div className="text-center text-gray-500 mt-8">
              <Package className="w-12 h-12 mx-auto mb-3 text-gray-400" />
              <div className="bg-white p-4 rounded-lg shadow max-w-md mx-auto text-left">
                <p className="font-semibold text-gray-800 mb-2">Hola 👋</p>
                <p className="text-gray-700 mb-2">Estoy aquí para ayudarte a elegir la bolsa perfecta para tu negocio.</p>
                <p className="text-cyan-600 font-semibold">¿Qué tipo de producto vendes?</p>
              </div>
            </div>
          )}
          {messages.map((msg, idx) => (
            <div
              key={idx}
              className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`max-w-[80%] p-3 rounded-lg ${
                  msg.type === 'user'
                    ? 'bg-magenta-500 text-white'
                    : 'bg-white text-gray-800 shadow'
                }`}
              >
                {msg.text}
              </div>
            </div>
          ))}
          {loading && (
            <div className="flex justify-start">
              <div className="bg-white p-3 rounded-lg shadow">
                <div className="flex gap-1">
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" />
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="p-4 border-t bg-white md:rounded-b-2xl">
          <div className="flex gap-2">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
              placeholder="Escribe tu pregunta..."
              className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-cyan-500 focus:outline-none"
              disabled={loading}
              data-testid="chat-input"
            />
            <button
              onClick={sendMessage}
              disabled={loading || !input.trim()}
              className="bg-magenta-500 hover:bg-magenta-600 disabled:bg-gray-300 text-white p-3 rounded-lg transition"
              data-testid="send-message-btn"
            >
              <Send className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// ALFOMBRAS PARA CARRO PERSONALIZADAS — Product line & Section
// ============================================================
const ALFOMBRAS_PRICING = {
  100: { price: 13, bonus: 0 },
  500: { price: 60, bonus: 50 },
  1000: { price: 110, bonus: 100 },
};

const ALFOMBRAS_COLOR_SURCHARGE = 8.99; // por cada color adicional al total

function calculateBonus(quantity) {
  if (quantity >= 1000) return 100;
  if (quantity >= 500) return 50;
  return 0;
}

function calculateAlfombrasBasePrice(quantity) {
  // Interpolación entre tiers: 100=$13, 500=$60, 1000=$110
  if (quantity <= 100) return 13;
  if (quantity >= 1000) return 110 + Math.ceil((quantity - 1000) / 100) * 11;
  if (quantity >= 500) {
    // Entre 500 y 1000: interpolación lineal ($60 → $110, +$0.10/unidad)
    return +(60 + (quantity - 500) * 0.10).toFixed(2);
  }
  // Entre 100 y 500: interpolación lineal ($13 → $60, +$0.1175/unidad)
  return +(13 + (quantity - 100) * 0.1175).toFixed(2);
}

function calculateAlfombrasPrice(quantity, printColors = 1) {
  const base = calculateAlfombrasBasePrice(quantity);
  const extra = Math.max(0, (printColors - 1)) * ALFOMBRAS_COLOR_SURCHARGE;
  return +(base + extra).toFixed(2);
}

const ALFOMBRAS_IMAGES = [
  'https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/n49om3nr_WhatsApp%20Image%202026-06-22%20at%2022.12.13.webp',
  'https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/k60oieba_Publicidad%20alfombras%20_Mesa%20de%20trabajo%201.webp',
  'https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/q6m2tvxc_Publicidad%20alfombras%20final_Mesa%20de%20trabajo%201%20copia.webp',
  'https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/qxai2rur_Publicidad%20alfombras%20final_Mesa%20de%20trabajo%201%20copia%202.webp',
  'https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/k58dok30_Publicidad%20alfombras%20final_Mesa%20de%20trabajo%201%20copia%203.webp',
  'https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/g1ny92hw_Publicidad%20alfombras%20final_Mesa%20de%20trabajo%201%20copia%204.webp',
];

function AlfombrasSection({ tasaBcv, onOpenModal }) {
  const [qty, setQty] = useState(100);
  const [printColors, setPrintColors] = useState(1);
  const bonus = calculateBonus(qty);
  const basePrice = calculateAlfombrasBasePrice(qty);
  const additionalColorsCost = +((Math.max(0, printColors - 1)) * ALFOMBRAS_COLOR_SURCHARGE).toFixed(2);
  const price = +(basePrice + additionalColorsCost).toFixed(2);
  const total = qty + bonus;
  const priceBs = tasaBcv ? (price * tasaBcv).toFixed(2) : '---';

  const dec = () => setQty(q => Math.max(100, q - 50));
  const inc = () => setQty(q => q + 50);

  const openModal = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout', { content_name: 'Alfombras', value: price, currency: 'USD', num_items: qty });
    }
    onOpenModal({
      quantity: qty,
      bonus,
      totalUnits: total,
      printColors,
      basePriceUsd: basePrice,
      additionalColorsCost,
      priceUsd: price,
    });
  };

  const plans = [
    { qty: 100, price: 13, bonus: 0, label: '100 UNIDADES', highlight: false },
    { qty: 500, price: 60, bonus: 50, label: '500 UNIDADES', highlight: true, badge: '+ 50 GRATIS · RECIBES 550' },
    { qty: 1000, price: 110, bonus: 100, label: '1000 UNIDADES', highlight: false, badge: '+ 100 GRATIS · RECIBES 1100' },
  ];

  return (
    <section id="alfombras-promo" className="relative py-14 md:py-20 overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-black">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-20 -left-20 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
      <div className="relative max-w-6xl mx-auto px-4">
        {/* HEADER */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-yellow-400 text-slate-900 text-xs font-black px-4 py-1.5 rounded-full mb-4 shadow-2xl animate-pulse">
            <span>🚗</span> OFERTA EXCLUSIVA WEB <span>🚗</span>
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-3 tracking-tight" style={{ letterSpacing: '-0.03em' }}>
            ALFOMBRAS PARA CARRO<br /><span className="text-cyan-400">PERSONALIZADAS</span>
          </h2>
          <p className="text-lg md:text-xl text-white font-bold mb-1">Tu marca también puede viajar con tus clientes.</p>
          <p className="text-sm md:text-base text-slate-300 max-w-2xl mx-auto">Ideal para autolavados, multiservicios, concesionarios y talleres. Convierte cada vehículo en publicidad rodante para tu negocio.</p>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-2 mt-5">
            <span className="inline-flex items-center gap-1.5 bg-white/10 border border-cyan-400/30 rounded-full px-3 py-1.5 text-[11px] font-bold text-cyan-200 uppercase tracking-wider">✓ 9 años de experiencia</span>
            <span className="inline-flex items-center gap-1.5 bg-white/10 border border-emerald-400/30 rounded-full px-3 py-1.5 text-[11px] font-bold text-emerald-200 uppercase tracking-wider">✓ Propuesta digital previa</span>
            <span className="inline-flex items-center gap-1.5 bg-white/10 border border-yellow-400/30 rounded-full px-3 py-1.5 text-[11px] font-bold text-yellow-200 uppercase tracking-wider">✓ Producción en Venezuela</span>
          </div>
        </div>

        {/* Galería de imágenes reales */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-10">
          {ALFOMBRAS_IMAGES.map((src, i) => (
            <div key={i} className="relative aspect-square rounded-xl overflow-hidden shadow-xl ring-1 ring-cyan-400/20 hover:ring-yellow-400/60 hover:scale-105 transition-all">
              <img
                src={src}
                alt={`Alfombra personalizada ${i + 1}`}
                data-testid={`alfombra-img-${i + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => { e.currentTarget.style.background = '#0f172a'; e.currentTarget.alt = 'Imagen no disponible'; }}
              />
            </div>
          ))}
        </div>

        {/* IDEAL PARA — target audience */}
        <div className="mb-10 bg-gradient-to-br from-cyan-900/40 to-slate-900/40 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-cyan-400/20">
          <p className="text-center text-cyan-300 text-xs uppercase tracking-widest font-black mb-4">✨ Ideal para tu negocio si tienes</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { icon: '🚿', title: 'Autolavado', desc: 'Deja tu marca en cada carro que lavas' },
              { icon: '🔧', title: 'Multiservicios', desc: 'Publicidad que rueda con tus clientes' },
              { icon: '🏪', title: 'Concesionario', desc: 'Regalo premium al entregar vehículo' },
              { icon: '⚙️', title: 'Taller mecánico', desc: 'Recordatorio de tu servicio 24/7' },
            ].map((s, i) => (
              <div key={i} className="bg-white/5 rounded-2xl p-4 text-center border border-white/10 hover:border-cyan-400/40 transition">
                <div className="text-3xl mb-2">{s.icon}</div>
                <p className="text-white font-black text-sm">{s.title}</p>
                <p className="text-slate-400 text-[11px] mt-1">{s.desc}</p>
              </div>
            ))}
          </div>

          {/* Recordatorio subliminal — Bolsa Talla S para autolavados */}
          <button
            onClick={() => {
              document.getElementById('precios')?.scrollIntoView({ behavior: 'smooth' });
              setTimeout(() => {
                const s = document.querySelector('[data-testid="add-to-cart-S_WHITE"]');
                if (s) s.closest('.rounded-2xl, .rounded-xl, div')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 800);
            }}
            data-testid="alfombras-tip-bolsa-s"
            className="mt-5 w-full text-left flex items-center gap-3 bg-gradient-to-r from-amber-500/10 via-amber-400/5 to-transparent border border-amber-400/25 hover:border-amber-400/60 rounded-xl px-4 py-3 transition group"
          >
            <span className="text-2xl">💡</span>
            <div className="flex-1">
              <p className="text-amber-200 font-bold text-[13px]">Tip para autolavados & multiservicios</p>
              <p className="text-slate-300 text-xs">Combínalas con nuestras <span className="text-amber-300 font-black underline decoration-dotted">bolsas Talla S personalizadas</span> — perfectas para entregar productos, promociones o guardar accesorios.</p>
            </div>
            <ChevronDown className="w-4 h-4 -rotate-90 text-amber-300 group-hover:translate-x-1 transition-transform flex-shrink-0" />
          </button>
        </div>

        {/* 3 tarjetas de planes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          {plans.map(p => (
            <div key={p.qty} className={`relative rounded-2xl p-5 shadow-2xl transition-all hover:scale-[1.03] ${p.highlight ? 'bg-gradient-to-br from-yellow-400 to-amber-500 text-slate-900 ring-4 ring-yellow-300' : 'bg-white/5 backdrop-blur-md border border-cyan-400/20 text-white'}`}>
              {p.highlight && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-red-500 text-white text-[10px] font-black px-3 py-1 rounded-full shadow-lg">🔥 MÁS POPULAR</div>}
              <p className={`text-xs uppercase font-bold tracking-widest ${p.highlight ? 'text-slate-700' : 'text-cyan-300'}`}>{p.label}</p>
              <p className={`text-5xl font-black tabular-nums my-2 ${p.highlight ? 'text-slate-900' : 'text-white'}`}>${p.price}</p>
              {p.bonus > 0 && <div className={`inline-block text-xs font-black px-2 py-1 rounded-full mb-1 ${p.highlight ? 'bg-red-500 text-white' : 'bg-emerald-500 text-white'}`}>+ {p.bonus} GRATIS</div>}
              <p className={`text-sm font-bold ${p.highlight ? 'text-slate-800' : 'text-emerald-300'}`}>{p.badge || `100 unidades desde $${p.price}`}</p>
              <button onClick={() => { setQty(p.qty); document.getElementById('alfombras-selector')?.scrollIntoView({ behavior: 'smooth' }); }} data-testid={`alfombras-plan-${p.qty}`} className={`mt-4 w-full py-2.5 rounded-xl font-black text-sm transition ${p.highlight ? 'bg-slate-900 text-yellow-300 hover:bg-slate-800' : 'bg-cyan-500 text-white hover:bg-cyan-400'}`}>ELEGIR ESTE PLAN</button>
            </div>
          ))}
        </div>

        {/* Selector de cantidad + colores + resumen */}
        <div id="alfombras-selector" className="bg-white/5 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-cyan-400/20 shadow-2xl">
          <h3 className="text-white font-black text-xl mb-4 text-center">Configura tu pedido</h3>

          {/* Cantidad */}
          <div className="mb-6">
            <p className="text-cyan-300 text-xs uppercase font-black tracking-widest mb-3 text-center">1. Elige tu cantidad</p>
            <div className="flex items-center justify-center gap-4 mb-2">
              <button onClick={dec} data-testid="alfombras-qty-dec" disabled={qty <= 100} className="w-14 h-14 rounded-2xl bg-slate-700 hover:bg-slate-600 disabled:opacity-30 text-white text-3xl font-black shadow-lg">−</button>
              <div className="bg-slate-900 rounded-2xl px-8 py-3 min-w-[140px] text-center border-2 border-cyan-400">
                <p className="text-4xl font-black text-white tabular-nums" data-testid="alfombras-qty">{qty}</p>
                <p className="text-[10px] text-cyan-300 uppercase tracking-widest">Unidades</p>
              </div>
              <button onClick={inc} data-testid="alfombras-qty-inc" className="w-14 h-14 rounded-2xl bg-cyan-500 hover:bg-cyan-400 text-white text-3xl font-black shadow-lg">+</button>
            </div>
            <p className="text-center text-xs text-slate-400">Mínimo 100 · Incrementos de 50</p>
          </div>

          {/* Colores de impresión */}
          <div className="mb-6">
            <p className="text-cyan-300 text-xs uppercase font-black tracking-widest mb-3 text-center">2. Colores de impresión</p>
            <div className="grid grid-cols-3 gap-2 max-w-md mx-auto">
              {[1, 2, 3].map(c => (
                <button
                  key={c}
                  onClick={() => setPrintColors(c)}
                  data-testid={`alfombras-colors-${c}`}
                  className={`py-3 rounded-xl font-black transition-all border-2 ${printColors === c ? 'bg-cyan-500 border-cyan-400 text-white shadow-lg scale-105' : 'bg-slate-800/60 border-slate-700 text-slate-300 hover:border-cyan-500/50'}`}
                >
                  <p className="text-lg">{c} {c === 1 ? 'color' : 'colores'}</p>
                  <p className="text-[10px] font-normal opacity-80">{c === 1 ? 'Incluido' : `+$${((c - 1) * ALFOMBRAS_COLOR_SURCHARGE).toFixed(2)}`}</p>
                </button>
              ))}
            </div>
            <p className="text-center text-[11px] text-slate-400 mt-2">Cada color adicional +${ALFOMBRAS_COLOR_SURCHARGE} al total del pedido</p>
          </div>

          {/* Resumen dinámico */}
          <div className="bg-slate-900 rounded-2xl p-5 space-y-2 text-white mb-5">
            <p className="text-cyan-300 text-xs uppercase font-bold tracking-widest mb-2">TU PEDIDO</p>
            <div className="flex justify-between text-sm"><span className="text-slate-300">Alfombras compradas:</span><span className="font-bold tabular-nums" data-testid="summary-qty">{qty}</span></div>
            <div className="flex justify-between text-sm"><span className="text-slate-300">Alfombras GRATIS:</span><span className="font-bold text-emerald-400 tabular-nums" data-testid="summary-bonus">{bonus}</span></div>
            <div className="flex justify-between text-sm border-t border-slate-700 pt-2"><span className="text-slate-300">Total que recibirás:</span><span className="font-black text-yellow-300 tabular-nums text-base" data-testid="summary-total">{total}</span></div>
            <div className="flex justify-between text-sm"><span className="text-slate-300">Impresión:</span><span className="font-bold tabular-nums">{printColors} {printColors === 1 ? 'color' : 'colores'}</span></div>
            <div className="flex justify-between text-xs text-slate-400"><span>Precio base:</span><span className="tabular-nums">${basePrice.toFixed(2)}</span></div>
            {additionalColorsCost > 0 && (
              <div className="flex justify-between text-xs text-slate-400"><span>Colores adicionales:</span><span className="tabular-nums">+${additionalColorsCost.toFixed(2)}</span></div>
            )}
            <div className="flex justify-between items-baseline pt-2 border-t border-slate-700">
              <span className="text-slate-300 font-bold">Total:</span>
              <div className="text-right">
                <p className="text-3xl font-black text-white tabular-nums" data-testid="summary-price">${price}</p>
                {tasaBcv && <p className="text-xs text-emerald-400">Bs. {priceBs}</p>}
              </div>
            </div>
          </div>

          <button onClick={openModal} data-testid="alfombras-buy-btn" className="relative w-full bg-gradient-to-r from-yellow-400 via-amber-400 to-yellow-500 hover:brightness-110 text-slate-900 py-5 rounded-2xl font-black text-xl shadow-2xl hover:shadow-yellow-500/50 transition-all hover:scale-[1.02] overflow-hidden group">
            <span className="relative z-10">🛒 COMPRAR AHORA</span>
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
              <div className="absolute top-0 -left-1/2 w-1/3 h-full" style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.55), transparent)', animation: 'btnShine 3s ease-in-out infinite' }}></div>
            </div>
          </button>

          {/* Nota envío */}
          <p className="text-center text-[11px] text-yellow-300/80 mt-3 font-semibold">⚠️ El envío se cotiza aparte según tu ubicación</p>

          {/* Cómo funciona - propuesta digital */}
          <div className="mt-8 bg-cyan-900/30 border border-cyan-400/30 rounded-2xl p-5">
            <p className="text-cyan-200 font-black text-sm mb-3 uppercase tracking-widest text-center">Primero visualiza · Después producimos</p>
            <div className="grid grid-cols-1 md:grid-cols-5 gap-2 text-center text-xs text-slate-200">
              {['📝 Realizas tu pedido', '📤 Envías tu logo', '🎨 Diseñamos propuesta', '📱 Recibes por WhatsApp', '🏭 Aprobada, producimos'].map((s, i) => <div key={i} className="bg-white/5 rounded-lg p-2 border border-cyan-400/10">{s}</div>)}
            </div>
          </div>
        </div>

        {/* Beneficios / por qué comprar con nosotros */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
          {[
            { icon: '🎨', title: 'Diseño previo GRATIS', desc: 'Recibes una propuesta digital antes de producir. Nada sale mal.' },
            { icon: '🏭', title: 'Producción propia', desc: '9 años imprimiendo. Tu pedido es hecho en Venezuela, sin intermediarios.' },
            { icon: '🛡️', title: 'Sin sorpresas', desc: 'Precio cerrado por adelantado. Tú apruebas el diseño antes de imprimir.' },
          ].map((b, i) => (
            <div key={i} className="bg-white/5 backdrop-blur-md rounded-2xl p-5 border border-white/10 hover:border-cyan-400/40 transition">
              <div className="text-3xl mb-2">{b.icon}</div>
              <p className="text-white font-black text-base mb-1">{b.title}</p>
              <p className="text-slate-300 text-sm">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


// =============================================================
// Proactive WhatsApp Bubble — appears after 25s on category sections
// =============================================================
function ProactiveWhatsAppBubble() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('proactive_wa_shown')) {
      setDismissed(true);
      return;
    }
    let timeoutId = null;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !timeoutId && !sessionStorage.getItem('proactive_wa_shown')) {
          timeoutId = setTimeout(() => {
            if (!sessionStorage.getItem('proactive_wa_shown')) {
              setVisible(true);
              sessionStorage.setItem('proactive_wa_shown', '1');
            }
          }, 25000);
        }
      });
    }, { threshold: 0.3 });

    const sections = ['precios', 'alfombras-promo'].map(id => document.getElementById(id)).filter(Boolean);
    sections.forEach(s => observer.observe(s));
    return () => {
      observer.disconnect();
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  const sendMessage = () => {
    const msg = encodeURIComponent('¡Hola! Me gustaría una cotización rápida. ¿Me pueden ayudar con medidas y precio?');
    window.open(`https://wa.me/584147552221?text=${msg}`, '_blank');
    setVisible(false);
  };

  if (dismissed || !visible) return null;

  return (
    <div className="fixed bottom-24 right-4 md:bottom-6 md:right-24 z-[60] max-w-xs animate-fade-slide-up" data-testid="proactive-whatsapp-bubble">
      <div className="relative bg-white rounded-2xl shadow-2xl border-2 border-green-500 p-4">
        <button
          onClick={() => setVisible(false)}
          data-testid="proactive-wa-close"
          className="absolute -top-2 -right-2 w-6 h-6 bg-slate-800 text-white rounded-full flex items-center justify-center text-xs hover:bg-slate-700"
          aria-label="Cerrar"
        >
          <X className="w-3 h-3" />
        </button>
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
            <MessageCircle className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1">
            <p className="font-black text-slate-900 text-sm mb-0.5">¿Dudas con medidas o precio?</p>
            <p className="text-xs text-slate-600 mb-2">Te respondemos ahora mismo por WhatsApp.</p>
            <button
              onClick={sendMessage}
              data-testid="proactive-wa-cta"
              className="w-full bg-green-500 hover:bg-green-600 text-white font-black text-xs py-2 rounded-lg transition flex items-center justify-center gap-1.5"
            >
              <MessageCircle className="w-3.5 h-3.5" /> Resolver mi duda
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


// =============================================================
// Mobile Floating Bar — fixed WhatsApp + Cart on mobile
// =============================================================
function MobileFloatingBar({ cartCount, onOpenCart }) {
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-slate-900/95 backdrop-blur-md border-t border-slate-700 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-testid="mobile-floating-bar">
      <div className="grid grid-cols-2 gap-0">
        <a
          href="https://wa.me/584147552221?text=Hola%2C%20quiero%20cotizar"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-fab-whatsapp"
          className="flex items-center justify-center gap-2 py-3 bg-green-500 hover:bg-green-600 text-white font-black text-sm transition active:scale-95"
        >
          <MessageCircle className="w-5 h-5" /> WhatsApp
        </a>
        <button
          onClick={onOpenCart}
          data-testid="mobile-fab-cart"
          className="relative flex items-center justify-center gap-2 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-black text-sm transition active:scale-95"
        >
          <ShoppingCart className="w-5 h-5" /> Carrito
          {cartCount > 0 && <span className="absolute top-1 right-6 bg-red-500 text-white text-[9px] font-black rounded-full w-4 h-4 flex items-center justify-center">{cartCount}</span>}
        </button>
      </div>
    </div>
  );
}


// =============================================================
// Lead Magnet Popup — Exit intent + 15s timer
// =============================================================
function LeadMagnetPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (sessionStorage.getItem('lead_magnet_shown')) return;

    const timer = setTimeout(() => {
      if (!sessionStorage.getItem('lead_magnet_shown')) {
        setOpen(true);
        sessionStorage.setItem('lead_magnet_shown', '1');
      }
    }, 40000);

    const onMouseLeave = (e) => {
      if (e.clientY < 10 && !sessionStorage.getItem('lead_magnet_shown')) {
        setOpen(true);
        sessionStorage.setItem('lead_magnet_shown', '1');
      }
    };
    document.addEventListener('mouseleave', onMouseLeave);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseleave', onMouseLeave);
    };
  }, []);

  const submit = async () => {
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      setError('Correo inválido');
      return;
    }
    setError('');
    try {
      await axios.post(`${API}/lead-magnet`, { email });
      setSubmitted(true);
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'Lead', { content_name: 'Guía Empaque PDF' });
      }
    } catch (e) {
      devError('lead-magnet failed', e);
      setError('No pudimos registrar tu correo. Inténtalo de nuevo.');
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[70] flex items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="lead-magnet-popup">
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-3xl max-w-md w-full p-6 relative shadow-2xl">
        <button onClick={() => setOpen(false)} data-testid="lead-close" className="absolute top-3 right-3 w-8 h-8 bg-slate-100 hover:bg-slate-200 rounded-full flex items-center justify-center">
          <X className="w-4 h-4" />
        </button>
        {!submitted ? (
          <>
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-2xl flex items-center justify-center mb-4 shadow-lg">
              <Sparkles className="w-8 h-8 text-white" />
            </div>
            <p className="text-xs uppercase tracking-widest text-amber-600 font-black mb-1">Regalo gratis</p>
            <h3 className="text-2xl font-black text-slate-900 mb-2 leading-tight">Guía del empaque que vende</h3>
            <p className="text-sm text-slate-600 mb-4">Descarga el PDF con medidas, materiales y 5 casos reales de marcas que convirtieron su empaque en una herramienta de ventas.</p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="lead-email-input"
              placeholder="tucorreo@ejemplo.com"
              className="w-full px-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl focus:border-amber-500 focus:bg-white focus:outline-none mb-2"
            />
            {error && <p className="text-xs text-red-600 mb-2">{error}</p>}
            <button onClick={submit} data-testid="lead-submit" className="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:brightness-110 text-white font-black py-3 rounded-xl shadow-lg">
              📥 QUIERO LA GUÍA GRATIS
            </button>
            <p className="text-[10px] text-center text-slate-400 mt-3">Sin spam. Solo contenido útil para que tu marca venda más.</p>
          </>
        ) : (
          <div className="text-center py-6" data-testid="lead-success">
            <div className="w-16 h-16 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-3">
              <CheckCircle className="w-8 h-8 text-white" strokeWidth={3} />
            </div>
            <h3 className="text-xl font-black text-slate-900 mb-1">¡Listo!</h3>
            <p className="text-sm text-slate-600 mb-4">Te enviamos la guía a tu correo. Revisa también la carpeta de promociones.</p>
            <button onClick={() => setOpen(false)} className="text-sm text-slate-500 underline">Cerrar</button>
          </div>
        )}
      </div>
    </div>
  );
}


function App() {
  const isAdminRoute = typeof window !== 'undefined' && window.location.pathname.replace(/\/$/, '') === '/admin';

  const [showChat, setShowChat] = useState(false);
  const [tasaBcv, setTasaBcv] = useState(null);
  const [purchaseModalOpen, setPurchaseModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [comboModalOpen, setComboModalOpen] = useState(false);
  const [alfombrasOrderData, setAlfombrasOrderData] = useState(null);
  const [bagPurchaseOpen, setBagPurchaseOpen] = useState(false);
  const [bagOrderData, setBagOrderData] = useState(null);
  const [cartItems, setCartItems] = useState(() => {
    try {
      const raw = localStorage.getItem('impre_cart');
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      devError('Corrupt impre_cart in localStorage, resetting:', e);
      return [];
    }
  });
  const [cartDrawerOpen, setCartDrawerOpen] = useState(false);
  const [cartCheckoutOpen, setCartCheckoutOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem('impre_cart', JSON.stringify(cartItems));
    } catch (e) {
      devError('Failed to persist cart to localStorage:', e);
    }
  }, [cartItems]);

  const handleAddToCart = (item) => {
    setCartItems(prev => {
      // Merge same product+color config: same sizeKey + printColors
      const idx = prev.findIndex(p => p.sizeKey === item.sizeKey && p.printColors === item.printColors);
      if (idx >= 0) {
        const copy = [...prev];
        const merged = { ...copy[idx], quantity: copy[idx].quantity + item.quantity };
        merged.subtotalUsd = +(merged.unitPriceUsd * merged.quantity).toFixed(2);
        copy[idx] = merged;
        return copy;
      }
      return [...prev, item];
    });
    setCartDrawerOpen(true);
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', { content_name: item.productName, content_ids: [item.sizeKey], value: item.subtotalUsd, currency: 'USD', num_items: item.quantity });
    }
  };

  const handleRemoveCartItem = (idx) => {
    setCartItems(prev => prev.filter((_, i) => i !== idx));
  };

  const handleBagBuy = (order) => {
    setBagOrderData(order);
    setBagPurchaseOpen(true);
  };
  const sectionsRef = useRef({});

  // Cargar tasa BCV al iniciar
  useEffect(() => {
    const fetchTasaBcv = async () => {
      try {
        const response = await axios.get(`${API}/tasa-bcv`);
        setTasaBcv(response.data.tasa);
      } catch (error) {
        devError('Error fetching BCV rate:', error);
        setTasaBcv(95); // Fallback
      }
    };
    fetchTasaBcv();
    // Actualizar cada 5 minutos
    const interval = setInterval(fetchTasaBcv, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handleShirtBuy = (orderData) => {
    setSelectedOrder(orderData);
    setPurchaseModalOpen(true);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <>
    {isAdminRoute ? <AdminPanel /> : (
    <div className="min-h-screen bg-gray-50">
      <Navbar scrollToSection={scrollToSection} cartCount={cartItems.length} onOpenCart={() => setCartDrawerOpen(true)} />

      {/* Hero Section */}
      <section id="hero" className="pt-28 pb-12 md:pt-36 md:pb-16 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
        {/* Background effects */}
        <div className="absolute inset-0">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500/20 blur-3xl rounded-full"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-magenta-500/20 blur-3xl rounded-full"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="text-center mb-10">
            <div className="mb-4">
              <span className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold">
                <Award className="w-4 h-4 text-yellow-400" />
                9 años de experiencia en artes gráficas
              </span>
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black mb-4 flex flex-col items-center gap-3">
              <span>Bienvenido a</span>
              <img src={LOGO_URL} alt="Impreplástico" className="h-14 md:h-24 w-auto" data-testid="hero-logo" />
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
              ¿Qué estás buscando hoy?
            </p>
          </div>

          {/* Selector de rutas */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            
            {/* Opción Bolsas */}
            <button
              onClick={() => {
                document.getElementById('precios').scrollIntoView({ behavior: 'smooth' });
              }}
              className="group relative bg-gradient-to-br from-cyan-600 to-cyan-800 p-8 rounded-3xl text-left hover:scale-105 transition-all duration-300 shadow-2xl shadow-cyan-500/20 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <div className="relative z-10">
                <Package className="w-12 h-12 mb-4 text-cyan-200" />
                <h3 className="text-2xl md:text-3xl font-black mb-2">Bolsas Personalizadas</h3>
                <p className="text-cyan-100 mb-4">Empaques con tu logo para tu negocio</p>
                <div className="flex items-center gap-2 text-white font-bold">
                  <span>Ver precios y cotizar</span>
                  <ChevronDown className="w-5 h-5 group-hover:translate-y-1 transition-transform" />
                </div>
              </div>
            </button>

            {/* Opción Alfombras — paleta automotriz (asfalto/chrome/ámbar) */}
            <button
              onClick={() => {
                document.getElementById('alfombras-promo')?.scrollIntoView({ behavior: 'smooth' });
              }}
              data-testid="hero-combo-btn"
              className="group relative p-8 rounded-3xl text-left hover:scale-105 transition-all duration-300 shadow-2xl overflow-hidden"
              style={{
                background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 45%, #111827 100%)',
                boxShadow: '0 25px 50px -12px rgba(251, 191, 36, 0.25), inset 0 1px 0 rgba(255,255,255,0.08)'
              }}
            >
              {/* Líneas de carretera diagonales */}
              <div className="absolute inset-0 opacity-[0.12] pointer-events-none" style={{
                backgroundImage: 'repeating-linear-gradient(115deg, transparent 0, transparent 24px, #fbbf24 24px, #fbbf24 28px, transparent 28px, transparent 60px)'
              }}></div>
              {/* Halo ámbar */}
              <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full pointer-events-none" style={{ background: 'radial-gradient(closest-side, rgba(251,191,36,0.35), transparent 70%)' }}></div>
              {/* Halo azul eléctrico inferior */}
              <div className="absolute -bottom-20 -left-16 w-56 h-56 rounded-full pointer-events-none" style={{ background: 'radial-gradient(closest-side, rgba(56,189,248,0.25), transparent 70%)' }}></div>
              {/* Shine sweep */}
              <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out pointer-events-none">
                <div className="w-1/3 h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12"></div>
              </div>
              {/* Badge NUEVO */}
              <div className="absolute top-4 right-4 flex items-center gap-1.5 bg-amber-400 text-slate-900 text-[10px] font-black px-3 py-1 rounded-full shadow-lg tracking-widest uppercase">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                Nuevo Lanzamiento
              </div>
              <div className="relative z-10">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-4 border border-amber-400/40" style={{ background: 'linear-gradient(135deg, rgba(251,191,36,0.15), rgba(56,189,248,0.1))' }}>
                  <span className="text-3xl" role="img" aria-label="car">🚗</span>
                </div>
                <h3 className="text-2xl md:text-3xl font-black mb-2 text-white tracking-tight">Alfombras para Carro</h3>
                <p className="text-slate-300 mb-4 text-sm">Publicidad que rueda con tus clientes · Desde <span className="text-amber-300 font-black">$13</span> · 100 unidades</p>
                <div className="flex items-center gap-2 text-amber-300 font-bold">
                  <span>¡Quiero cotizar!</span>
                  <ChevronDown className="w-5 h-5 -rotate-90 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </button>

          </div>
        </div>
      </section>

      {/* TRUST BAR — marcas que confían en Impreplástico */}
      <section className="py-10 bg-slate-950 border-y border-slate-800" data-testid="trust-bar">
        <div className="max-w-7xl mx-auto px-4">
          <p className="text-center text-slate-400 text-xs md:text-sm uppercase tracking-[0.3em] font-bold mb-6">
            Marcas que ya producen con nosotros
          </p>
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-6 items-center justify-items-center">
            {[
              { name: 'StyleShop', url: 'https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/s8qnkq2q_STYLESHOP%205%20kilos%20-02.png' },
              { name: 'Sosa Store', url: 'https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/gpu4rxhn_sosa%20store%20Propuesta%20QR_Beehoven%20%20copia.png' },
              { name: 'Kova', url: 'https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/mf0ra96w_Kova%20Store%20-04.png' },
              { name: 'Claret', url: 'https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/a7mf2k6z_Claret%20Propuesta%20Digital-21.png' },
              { name: 'Mariange', url: 'https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/vsmo1w2f_mariange%20web_Mesa%20de%20trabajo%201.png' },
              { name: 'Fashion', url: 'https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/i981ut3b_fashion%20web_Mesa%20de%20trabajo%201.png' },
              { name: 'Euph', url: 'https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/d6io72ya_euph%20web_Mesa%20de%20trabajo%201.png' },
              { name: 'Vincenzo', url: 'https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/m0y7ubqg_VINCENZO%20Web_Mesa%20de%20trabajo%201-04.png' },
            ].map((c) => (
              <div key={c.name} className="relative h-14 w-full flex items-center justify-center group" data-testid={`trust-logo-${c.name.toLowerCase().replace(/\s/g, '-')}`}>
                <img
                  src={c.url}
                  alt={`Cliente ${c.name}`}
                  loading="lazy"
                  className="max-h-14 max-w-[110px] w-auto object-contain opacity-55 grayscale group-hover:opacity-100 group-hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
          <p className="text-center text-slate-500 text-xs mt-6 italic">+ Boutiques, autolavados, concesionarios y emprendedores en toda Venezuela</p>
        </div>
      </section>


      {/* ALFOMBRAS PARA CARRO PERSONALIZADAS */}
      <AlfombrasSection tasaBcv={tasaBcv} onOpenModal={(orderData) => { setAlfombrasOrderData(orderData); setComboModalOpen(true); }} />


      {/* Benefits Section */}
      <section className="py-12 bg-white border-y">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-cyan-100 rounded-full mb-4">
                <Package className="w-8 h-8 text-cyan-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Bolsas que Venden</h3>
              <p className="text-gray-600">Convertimos empaques en herramientas de marketing</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-magenta-100 rounded-full mb-4">
                <CheckCircle className="w-8 h-8 text-magenta-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Calidad Profesional</h3>
              <p className="text-gray-600">Impresión de alta calidad que refleja tu marca</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mb-4">
                <Clock className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Entrega Puntual</h3>
              <p className="text-gray-600">Cumplimiento garantizado en tiempos acordados</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="precios" className="py-16 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
              Tallas y Precios
            </h2>
            <p className="text-xl text-gray-600 mb-2">
              Calcula tu precio en tiempo real
            </p>
            {tasaBcv && (
              <p className="text-sm text-green-600 font-semibold">
                💵 Tasa BCV del día: Bs. {tasaBcv.toFixed(2)}
              </p>
            )}
          </div>

          {/* Sección Bolsas Blancas con Fuelle - NUEVO */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <h3 className="text-2xl font-bold text-gray-800">🆕 Bolsas Blancas</h3>
              <span className="bg-yellow-400 text-black text-xs font-black px-3 py-1 rounded-full animate-pulse">CON FUELLE NUEVO</span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
              {['S_WHITE', 'M_WHITE', 'L_WHITE', 'XL_WHITE'].map(key => (
                <SizeModule key={key} sizeKey={key} data={pricingData[key]} tasaBcv={tasaBcv} onOpenChat={() => setShowChat(true)} onBuy={handleBagBuy} onAddToCart={handleAddToCart} />
              ))}
            </div>
          </div>

          {/* Sección Bolsas Negras — Incluye envío + descuento por volumen */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6 flex-wrap">
              <h3 className="text-2xl font-bold text-gray-800">🖤 Bolsas Negras</h3>
              <span className="bg-amber-400 text-black text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest">✓ Envío incluido</span>
              <span className="bg-emerald-500 text-white text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest">Hasta -25% por volumen</span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {['S_BLACK', 'M_BLACK', 'L_BLACK'].map(key => (
                <SizeModule key={key} sizeKey={key} data={pricingData[key]} tasaBcv={tasaBcv} onOpenChat={() => setShowChat(true)} onBuy={handleBagBuy} onAddToCart={handleAddToCart} />
              ))}
            </div>
          </div>

          {/* Sección Bolsas Transparentes - 20% Descuento */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <h3 className="text-2xl font-bold text-gray-800">💎 Bolsas Transparentes</h3>
              <span className="bg-cyan-500 text-white text-xs font-bold px-3 py-1 rounded-full">-20% Descuento</span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-6 max-w-xl">
              <SizeModule key="TRANSPARENT" sizeKey="TRANSPARENT" data={pricingData.TRANSPARENT} tasaBcv={tasaBcv} onOpenChat={() => setShowChat(true)} onBuy={handleBagBuy} onAddToCart={handleAddToCart} />
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="inline-flex items-center gap-2 bg-yellow-100 border-2 border-yellow-400 px-6 py-3 rounded-full">
              <Truck className="w-5 h-5 text-yellow-700" />
              <span className="font-bold text-yellow-700">Envío GRATIS a todo el país</span>
            </div>
          </div>
        </div>
      </section>

      {/* IMPREPLASTICO STORE - Mundial 2026 */}
      {/* PROPUESTA DIGITAL — Showcase de cómo trabajamos */}
      <section id="propuesta-digital" className="py-16 md:py-24 bg-gradient-to-br from-slate-900 via-slate-950 to-black text-white relative overflow-hidden" data-testid="propuesta-digital-section">
        <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, #06b6d4 0%, transparent 40%), radial-gradient(circle at 80% 70%, #f59e0b 0%, transparent 40%)' }}></div>

        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <span className="inline-block bg-amber-400 text-black text-xs font-black uppercase tracking-[0.3em] px-4 py-1.5 rounded-full mb-4">Primero visualizas · Después producimos</span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-black mb-3 tracking-tight">
              Propuesta <span className="bg-gradient-to-r from-amber-300 via-amber-400 to-amber-500 bg-clip-text text-transparent">Digital</span> Incluida
            </h2>
            <p className="text-slate-300 max-w-2xl mx-auto text-base md:text-lg">
              Antes de imprimir un solo producto, te enviamos una propuesta digital con tu diseño adaptado. Si no te gusta, lo ajustamos. Si te gusta, producimos. <span className="text-amber-300 font-bold">Cero sorpresas.</span>
            </p>
          </div>

          {/* Grid de propuestas reales */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
            <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-testid="propuesta-ejemplo-alfombra">
              <div className="absolute top-4 left-4 z-10 bg-cyan-500 text-white text-[10px] font-black uppercase tracking-widest px-3 py-1 rounded-full shadow-lg">🚗 Alfombra Carro</div>
              <img
                src="https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/l0ftfqnp_Autolavado%20MC_Mesa%20de%20trabajo%201.webp"
                alt="Propuesta digital alfombra para Multiservicios Tu Confianza"
                className="w-full h-auto object-contain"
                loading="lazy"
              />
              <div className="p-5 bg-gradient-to-br from-slate-50 to-slate-100">
                <p className="text-xs uppercase tracking-widest text-slate-500 font-bold mb-1">Cliente real</p>
                <p className="font-black text-slate-900 text-lg">Multiservicios Tu Confianza C.A.</p>
                <p className="text-xs text-slate-600">Trujillo · Autolavado + Engrase + Lubricantes</p>
              </div>
            </div>

            <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-testid="propuesta-ejemplo-bolsa">
              <div className="absolute top-4 left-4 z-10 bg-pink-500 text-white text-[10px] font-black uppercase tracking-widest px-3 py-1 rounded-full shadow-lg">👛 Bolsa Boutique</div>
              <img
                src="https://customer-assets-jai6qajn.emergentagent.net/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/yk8u0ul1_Succ%C3%A8s-1.png"
                alt="Propuesta digital bolsa talla S negra para Succès"
                className="w-full h-auto object-contain"
                loading="lazy"
              />
              <div className="p-5 bg-gradient-to-br from-slate-50 to-slate-100">
                <p className="text-xs uppercase tracking-widest text-slate-500 font-bold mb-1">Cliente real</p>
                <p className="font-black text-slate-900 text-lg">Succès</p>
                <p className="text-xs text-slate-600">Boutique · Bolsa Talla S Negra · Impresión 1 Color</p>
              </div>
            </div>
          </div>

          {/* 4 pasos del flujo */}
          <div className="bg-white/5 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-white/10">
            <p className="text-center text-amber-300 text-xs uppercase tracking-widest font-black mb-6">¿Cómo funciona?</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { n: 1, t: 'Nos envías tu logo', d: 'Por WhatsApp o email, en el formato que tengas' },
                { n: 2, t: 'Diseñamos', d: 'Adaptamos tu marca al producto en 24-48 h' },
                { n: 3, t: 'Apruebas', d: 'Recibes la propuesta digital para visualizar' },
                { n: 4, t: 'Producimos', d: 'Con tu OK iniciamos la producción' },
              ].map((s) => (
                <div key={s.n} className="relative bg-slate-800/60 border border-slate-700 rounded-2xl p-4 hover:border-amber-400/50 transition-colors">
                  <div className="absolute -top-3 -left-3 w-9 h-9 bg-amber-400 text-black rounded-full flex items-center justify-center font-black shadow-lg">{s.n}</div>
                  <p className="font-black text-sm mt-2">{s.t}</p>
                  <p className="text-xs text-slate-400 mt-1">{s.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* IMPRESIÓN TEXTIL — Nueva línea de negocio */}
      <section id="impresion-textil" className="py-16 md:py-24 bg-gradient-to-br from-pink-50 via-amber-50 to-cyan-50 relative overflow-hidden" data-testid="impresion-textil-section">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 left-10 w-72 h-72 bg-pink-200/40 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-72 h-72 bg-cyan-200/40 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="text-center mb-10">
            <span className="inline-block bg-slate-900 text-white text-[10px] font-black uppercase tracking-[0.3em] px-4 py-1.5 rounded-full mb-4">Próximamente</span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-black mb-3 tracking-tight text-slate-900 flex flex-wrap items-center justify-center gap-3">
              <img src={LOGO_URL} alt="Impreplástico" className="h-10 md:h-16 w-auto inline-block" />
              <span className="bg-gradient-to-r from-pink-500 via-amber-500 to-cyan-500 bg-clip-text text-transparent">Impresión Textil</span>
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-base md:text-lg">
              Franelas, chemises, gorras y uniformes personalizados con tu marca. La misma calidad de 9 años, ahora también sobre tela.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            {[
              { icon: '🖨️', title: 'Serigrafía', desc: 'Durable y económica para alto volumen. Perfecta para uniformes de equipo.' },
              { icon: '🎨', title: 'Sublimación', desc: 'Full color sin límites. Ideal para diseños con fotos, degradados y detalle.' },
              { icon: '🧵', title: 'Bordado', desc: 'Premium y permanente. El toque corporativo que distingue a tu marca.' },
            ].map((t) => (
              <div key={t.title} className="bg-white rounded-3xl p-6 shadow-xl border border-slate-100 hover:border-amber-300 hover:-translate-y-1 transition-all">
                <div className="text-4xl mb-3">{t.icon}</div>
                <h3 className="font-black text-slate-900 text-xl mb-2">{t.title}</h3>
                <p className="text-slate-600 text-sm">{t.desc}</p>
              </div>
            ))}
          </div>

          {/* Público objetivo */}
          <div className="bg-white/70 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-white shadow-xl mb-8">
            <p className="text-center text-slate-500 text-xs uppercase tracking-widest font-black mb-5">Ideal para</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {[
                { icon: '👕', label: 'Uniformes corporativos' },
                { icon: '⚽', label: 'Equipos deportivos' },
                { icon: '🎉', label: 'Eventos y promos' },
                { icon: '🏪', label: 'Merchandising de marca' },
              ].map((p) => (
                <div key={p.label} className="text-center bg-slate-50 rounded-2xl p-4">
                  <div className="text-3xl mb-1">{p.icon}</div>
                  <p className="font-bold text-slate-800 text-xs md:text-sm">{p.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <a
              href="https://wa.me/584147552221?text=Hola%2C%20quiero%20cotizar%20impresi%C3%B3n%20textil"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="impresion-textil-cta"
              className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-black px-8 py-4 rounded-full shadow-xl hover:shadow-2xl transition-all hover:scale-[1.03]"
            >
              <MessageCircle className="w-5 h-5" />
              Cotizar mi impresión textil
            </a>
            <p className="text-xs text-slate-500 mt-3">Respuesta en menos de 1 hora en horario laboral</p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="nosotros" className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">
                Más de 9 años transformando marcas
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Impreplástico es una empresa de artes gráficas con más de 9 años de experiencia en impresión y personalización de bolsas plásticas y empaques comerciales.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Trabajamos con emprendedores, tiendas y marcas que desean proyectar una imagen profesional y diferenciarse en el mercado.
              </p>
              <p className="text-lg font-semibold text-cyan-600">
                No solo imprimimos bolsas, ayudamos a que tu marca destaque desde el primer vistazo.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 p-6 rounded-2xl text-center">
                <div className="text-4xl font-bold text-cyan-600 mb-2">9+</div>
                <div className="text-gray-700 font-semibold">Años de Experiencia</div>
              </div>
              <div className="bg-gradient-to-br from-magenta-50 to-magenta-100 p-6 rounded-2xl text-center">
                <div className="text-4xl font-bold text-magenta-600 mb-2">100%</div>
                <div className="text-gray-700 font-semibold">Calidad Garantizada</div>
              </div>
              <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 p-6 rounded-2xl text-center">
                <div className="text-4xl font-bold text-yellow-600 mb-2">500+</div>
                <div className="text-gray-700 font-semibold">Proyectos Realizados</div>
              </div>
              <div className="bg-gradient-to-br from-cyan-50 to-magenta-50 p-6 rounded-2xl text-center">
                <div className="text-4xl font-bold bg-gradient-to-r from-cyan-600 to-magenta-600 bg-clip-text text-transparent mb-2">24h</div>
                <div className="text-gray-700 font-semibold">Respuesta Rápida</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicios" className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
              Nuestros Servicios
            </h2>
            <p className="text-xl text-gray-600">
              Soluciones completas para tu marca
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition">
              <div className="w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center mb-4">
                <Package className="w-6 h-6 text-cyan-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Bolsas Plásticas Impresas</h3>
              <p className="text-gray-600">Personalización con logo, marca o diseño corporativo para que tu negocio destaque.</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition">
              <div className="w-12 h-12 bg-magenta-100 rounded-lg flex items-center justify-center mb-4">
                <CheckCircle className="w-6 h-6 text-magenta-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Impresión en Empaques</h3>
              <p className="text-gray-600">Soluciones visuales para negocios que quieren posicionarse y proyectar profesionalismo.</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                <Award className="w-6 h-6 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Asesoría en Diseño</h3>
              <p className="text-gray-600">Te orientamos para que tu diseño se imprima correctamente y luzca profesional.</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition">
              <div className="w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center mb-4">
                <Users className="w-6 h-6 text-cyan-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Producción por Volumen</h3>
              <p className="text-gray-600">Ideal para tiendas, boutiques y marcas en crecimiento. Precios competitivos.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="trabajos" className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
              Nuestros Trabajos
            </h2>
            <p className="text-xl text-gray-600">
              Calidad que habla por sí sola
            </p>
          </div>
          
          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Trabajo 1 - Captura & Conecta */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/chasnmqr_captura%20web_Mesa%20de%20trabajo%201-04.png"
                alt="Captura & Conecta"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Captura & Conecta</h3>
                  <p className="text-sm">Bolsa personalizada</p>
                </div>
              </div>
            </div>

            {/* Trabajo 2 - Claret */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/a7mf2k6z_Claret%20Propuesta%20Digital-21.png"
                alt="Claret"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Claret</h3>
                  <p className="text-sm">Bolsa boutique elegante</p>
                </div>
              </div>
            </div>

            {/* Trabajo 3 - M.D Clothing Store */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/me8i7maj_clothing%20web_Mesa%20de%20trabajo%201.png"
                alt="M.D Clothing Store"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-yellow-500 text-gray-800 px-3 py-1 rounded-full text-xs font-bold shadow-lg">📍 Enviado a Mérida</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">M.D Clothing Store</h3>
                  <p className="text-sm">Diseño minimalista • Tovar, Mérida</p>
                </div>
              </div>
            </div>

            {/* Trabajo 4 - Euphoria */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/d6io72ya_euph%20web_Mesa%20de%20trabajo%201.png"
                alt="Euphoria"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Euphoria</h3>
                  <p className="text-sm">Diseño urbano y creativo</p>
                </div>
              </div>
            </div>

            {/* Trabajo 5 - JR Fashion Shop */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/i981ut3b_fashion%20web_Mesa%20de%20trabajo%201.png"
                alt="JR Fashion Shop"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">JR Fashion Shop</h3>
                  <p className="text-sm">Estilo dorado premium</p>
                </div>
              </div>
            </div>

            {/* Trabajo 6 - Mariangelly Style */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/vsmo1w2f_mariange%20web_Mesa%20de%20trabajo%201.png"
                alt="Mariangelly Style"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-yellow-500 text-gray-800 px-3 py-1 rounded-full text-xs font-bold shadow-lg">📍 Enviado a Mérida</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Mariangelly Style</h3>
                  <p className="text-sm">Boutique fashion • Mérida</p>
                </div>
              </div>
            </div>

            {/* Trabajo 7 - MG Shop */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/ka27vcvk_MG%20WEB_Mesa%20de%20trabajo%201.png"
                alt="MG Shop"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-yellow-500 text-gray-800 px-3 py-1 rounded-full text-xs font-bold shadow-lg">📍 Enviado a Ciudad Bolívar</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">MG Shop</h3>
                  <p className="text-sm">Para ellas • Ciudad Bolívar</p>
                </div>
              </div>
            </div>

            {/* Trabajo 8 - Star Game */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/35hm2w9i_star%20game%20web_Mesa%20de%20trabajo%201.png"
                alt="Star Game"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-yellow-500 text-gray-800 px-3 py-1 rounded-full text-xs font-bold shadow-lg">📍 Enviado a Zulia</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Star Game</h3>
                  <p className="text-sm">Gaming store • Ojeda, Zulia</p>
                </div>
              </div>
            </div>

            {/* Trabajo 9 - Vincenzo */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/m0y7ubqg_VINCENZO%20Web_Mesa%20de%20trabajo%201-04.png"
                alt="Vincenzo"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-yellow-500 text-gray-800 px-3 py-1 rounded-full text-xs font-bold shadow-lg">📍 Enviado a Maracaibo</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Vincenzo</h3>
                  <p className="text-sm">Potencia tu estilo • Maracaibo</p>
                </div>
              </div>
            </div>

            {/* Trabajo 10 - Farmacia Las 3 Chinitas */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/yr72udv6_WhatsApp%20Image%202024-10-19%20at%2023.19.36.jpeg"
                alt="Farmacia Las 3 Chinitas"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-yellow-500 text-gray-800 px-3 py-1 rounded-full text-xs font-bold shadow-lg">📍 Enviado a Mérida</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Farmacia Las 3 Chinitas</h3>
                  <p className="text-sm">Sector salud • Mérida</p>
                </div>
              </div>
            </div>

            {/* Trabajo 11 - Sosa Store */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/gpu4rxhn_sosa%20store%20Propuesta%20QR_Beehoven%20%20copia.png"
                alt="Sosa Store"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Sosa Store</h3>
                  <p className="text-sm">Tienda de importaciones</p>
                </div>
              </div>
            </div>

            {/* Trabajo 12 - Style Shop */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/s8qnkq2q_STYLESHOP%205%20kilos%20-02.png"
                alt="Style Shop"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Style Shop</h3>
                  <p className="text-sm">Felicidad en cada paquete</p>
                </div>
              </div>
            </div>

            {/* Trabajo 13 - Etiqueta Venezolana */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/8yxvnk0x_etiqueta%20para%20web_Mesa%20de%20trabajo%201.png"
                alt="Etiqueta Venezolana"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Etiqueta Venezolana</h3>
                  <p className="text-sm">Tu esencia, tu orgullo, tu país</p>
                </div>
              </div>
            </div>

            {/* Trabajo 14 - Velo */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/0xyxrgk0_bolsa%20Velo%20.jpeg"
                alt="Velo"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Velo</h3>
                  <p className="text-sm">Diseño que se ve, marca que se siente</p>
                </div>
              </div>
            </div>

            {/* Trabajo 15 - Más Natural (vista superior) */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/tp2ydokf_bolsa%20natural%202.jpeg"
                alt="Más Natural"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Más Natural</h3>
                  <p className="text-sm">Tienda Naturista · Cd. Bolívar</p>
                </div>
              </div>
            </div>

            {/* Trabajo 16 - Más Natural (vista en pila) */}
            <div className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/2mtmhl9r_bolsa%20natural%203.jpeg"
                alt="Más Natural - Producción"
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white w-full">
                  <h3 className="text-xl font-bold mb-1">Más Natural</h3>
                  <p className="text-sm">Producción en serie · Calidad uniforme</p>
                </div>
              </div>
            </div>

            {/* CTA Card */}
            <div className="bg-gradient-to-br from-cyan-50 via-magenta-50 to-yellow-50 rounded-2xl p-8 flex items-center justify-center shadow-xl border-2 border-dashed border-gray-300">
              <div className="text-center">
                <Package className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                <h3 className="text-xl font-bold text-gray-700 mb-2">¿Tu proyecto?</h3>
                <p className="text-gray-600 mb-4 text-sm">Hagamos que tu marca destaque con nuestras bolsas personalizadas</p>
                <button
                  onClick={() => window.open('https://wa.me/584147552221', '_blank')}
                  className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full font-semibold transition shadow-lg"
                >
                  Solicitar Cotización
                </button>
              </div>
            </div>
          </div>

          {/* Envíos Badge */}
          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-4 font-semibold">Envíos a todo el país</p>
            <div className="flex flex-wrap justify-center gap-3">
              <span className="bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold">Mérida</span>
              <span className="bg-magenta-100 text-magenta-700 px-4 py-2 rounded-full text-sm font-semibold">Maracaibo</span>
              <span className="bg-yellow-100 text-yellow-700 px-4 py-2 rounded-full text-sm font-semibold">Ciudad Bolívar</span>
              <span className="bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold">Zulia</span>
              <span className="bg-magenta-100 text-magenta-700 px-4 py-2 rounded-full text-sm font-semibold">Caracas</span>
              <span className="bg-yellow-100 text-yellow-700 px-4 py-2 rounded-full text-sm font-semibold">Y más...</span>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section - Diseño Compacto y Profesional */}
      <section id="resenas" className="py-12 md:py-16 bg-gray-50" data-testid="reviews-section">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-2">
              Clientes Satisfechos
            </h2>
            <p className="text-base text-gray-600">
              Testimonios y entregas reales
            </p>
          </div>

          {/* Grid Principal - Capturas + Videos + Fotos */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-8">
            
            {/* Captura WhatsApp 1 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition group" data-testid="testimonial-1">
              <div className="p-2 bg-green-500 flex items-center gap-2">
                <MessageCircle className="w-3 h-3 text-white" />
                <span className="text-xs text-white font-medium">WhatsApp</span>
              </div>
              <div className="p-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/3kr7hpra_captura-02.png"
                  alt="Testimonio WhatsApp"
                  className="w-full h-32 object-cover rounded-lg"
                />
              </div>
            </div>

            {/* Captura WhatsApp 2 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition group" data-testid="testimonial-2">
              <div className="p-2 bg-green-500 flex items-center gap-2">
                <MessageCircle className="w-3 h-3 text-white" />
                <span className="text-xs text-white font-medium">WhatsApp</span>
              </div>
              <div className="p-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/r35nda8u_capture%202-02.png"
                  alt="Testimonio WhatsApp 2"
                  className="w-full h-32 object-cover rounded-lg"
                />
              </div>
            </div>

            {/* Foto Bolsa Dorada */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition group" data-testid="bag-photo-1">
              <div className="p-2 bg-gradient-to-r from-yellow-500 to-yellow-600 flex items-center gap-2">
                <Award className="w-3 h-3 text-white" />
                <span className="text-xs text-white font-medium">Entrega Real</span>
              </div>
              <div className="p-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/wkprjhpr_IMG-20260209-WA0024.jpg.jpeg"
                  alt="Bolsa Dorada Premium"
                  className="w-full h-32 object-cover rounded-lg"
                />
              </div>
            </div>

            {/* Foto Bolsa Negra */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition group" data-testid="bag-photo-2">
              <div className="p-2 bg-gradient-to-r from-gray-700 to-gray-800 flex items-center gap-2">
                <Award className="w-3 h-3 text-white" />
                <span className="text-xs text-white font-medium">Entrega Real</span>
              </div>
              <div className="p-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/0t7aok83_IMG-20260209-WA0030.jpg.jpeg"
                  alt="Bolsa Negra Elegante"
                  className="w-full h-32 object-cover rounded-lg"
                />
              </div>
            </div>
          </div>

          {/* Videos de Clientes - Compactos */}
          <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 mb-6">
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="w-8 h-8 bg-magenta-100 rounded-full flex items-center justify-center">
                <MessageCircle className="w-4 h-4 text-magenta-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-800">Videos de Clientes</h3>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              {/* Video 1 */}
              <div className="relative rounded-lg overflow-hidden shadow-md" data-testid="client-video-1">
                <video 
                  controls 
                  className="w-full h-36 md:h-40 object-cover bg-gray-900"
                  preload="metadata"
                >
                  <source src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/sfove2r6_VID-20260210-WA0009.mp4" type="video/mp4" />
                </video>
              </div>

              {/* Video 2 */}
              <div className="relative rounded-lg overflow-hidden shadow-md" data-testid="client-video-2">
                <video 
                  controls 
                  className="w-full h-36 md:h-40 object-cover bg-gray-900"
                  preload="metadata"
                >
                  <source src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/768ackba_Video%20de%20WhatsApp%202025-08-21%20a%20las%2015.24.55_f88942d7.mp4" type="video/mp4" />
                </video>
              </div>

              {/* Video 3 */}
              <div className="relative rounded-lg overflow-hidden shadow-md" data-testid="client-video-3">
                <video 
                  controls 
                  className="w-full h-36 md:h-40 object-cover bg-gray-900"
                  preload="metadata"
                >
                  <source src="https://customer-assets.emergentagent.com/job_hola-connect-193/artifacts/ffbyazlz_Video%20de%20WhatsApp%202025-08-21%20a%20las%2015.25.29_ff9fbcb7.mp4" type="video/mp4" />
                </video>
              </div>

              {/* Video 4 - Nuevo */}
              <div className="relative rounded-lg overflow-hidden shadow-md" data-testid="client-video-4">
                <video 
                  controls 
                  className="w-full h-36 md:h-40 object-cover bg-gray-900"
                  preload="metadata"
                >
                  <source src="https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/qjzwmvde_capture.mp4" type="video/mp4" />
                </video>
              </div>

              {/* Video 5 - Nuevo */}
              <div className="relative rounded-lg overflow-hidden shadow-md" data-testid="client-video-5">
                <video 
                  controls 
                  className="w-full h-36 md:h-40 object-cover bg-gray-900"
                  preload="metadata"
                >
                  <source src="https://customer-assets.emergentagent.com/job_c6f9cda1-5ec5-40e6-95e7-7d944abb13d9/artifacts/njnonhis_WhatsApp%20Video%202024-09-20%20at%2000.12.19.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>

          {/* CTA Compacto */}
          <div className="text-center bg-gradient-to-r from-cyan-500 via-magenta-500 to-yellow-500 rounded-xl p-5 text-white">
            <h3 className="text-lg md:text-xl font-bold mb-2">¿Listo para ser nuestro próximo cliente satisfecho?</h3>
            <button
              onClick={() => window.open('https://wa.me/584147552221', '_blank')}
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-2.5 rounded-full font-bold text-sm shadow-lg transition"
              data-testid="reviews-cta-btn"
            >
              Solicitar Cotización
            </button>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
              Preguntas Frecuentes
            </h2>
            <p className="text-xl text-gray-600">
              ¿Tienes dudas?
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8">
            {faqData.map((item, idx) => (
              <FAQItem key={idx} question={item.q} answer={item.a} />
            ))}
          </div>

          <div className="text-center mt-8">
            <p className="text-gray-600 mb-4">¿No encuentras la respuesta que buscas?</p>
            <button
              onClick={() => window.open('https://wa.me/584147552221', '_blank')}
              className="bg-gradient-to-r from-cyan-500 to-magenta-500 text-white px-8 py-3 rounded-full font-bold hover:shadow-xl transition"
            >
              Escríbenos por WhatsApp
            </button>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contacto" className="py-16 md:py-24 bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-magenta-500 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="text-sm font-semibold text-cyan-400 uppercase tracking-wider">CONTÁCTANOS</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-4">
              Hagamos realidad <span className="text-cyan-400">tu proyecto</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Estamos listos para asesorarte y crear la solución perfecta para tu marca
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            {/* Left side - Contact info cards */}
            <div className="space-y-4">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center">
                      <Phone className="w-6 h-6 text-cyan-400" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-1">WhatsApp</h3>
                    <p className="text-gray-400 text-sm mb-2">La forma más rápida de contactarnos</p>
                    <a href="https://wa.me/584147552221" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 font-semibold">
                      +58414 7552221
                    </a>
                  </div>
                </div>
              </div>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-magenta-500/20 rounded-lg flex items-center justify-center">
                      <Mail className="w-6 h-6 text-magenta-400" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-1">Correo Electrónico</h3>
                    <p className="text-gray-400 text-sm mb-2">Envíanos tu consulta por email</p>
                    <a href="mailto:impreplast12@gmail.com" className="text-magenta-400 hover:text-magenta-300 font-semibold break-all">
                      impreplast12@gmail.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                      <MapPin className="w-6 h-6 text-yellow-400" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-1">Ubicación</h3>
                    <p className="text-gray-300">Mérida, Venezuela</p>
                  </div>
                </div>
              </div>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center">
                      <Clock className="w-6 h-6 text-cyan-400" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold mb-1">Horario de Atención</h3>
                    <p className="text-gray-300">Lunes a Sábado: 8:30 AM - 6:30 PM</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right side - CTA Card with gradient border */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 via-magenta-500 to-yellow-500 rounded-2xl blur-sm"></div>
              <div className="relative bg-gray-800 rounded-2xl p-8 border-2 border-transparent bg-clip-padding">
                <div className="absolute inset-0 rounded-2xl" style={{
                  background: 'linear-gradient(to right, #06B6D4, #EC4899, #F59E0B)',
                  WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude',
                  padding: '2px'
                }}></div>
                
                <div className="text-center mb-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-cyan-500 to-magenta-500 rounded-full mb-4">
                    <MessageCircle className="w-8 h-8" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2">¡Hablemos de tu proyecto!</h3>
                  <p className="text-gray-400">
                    Respuesta inmediata por WhatsApp. Sin compromiso, totalmente gratis.
                  </p>
                </div>

                <div className="space-y-3">
                  <button
                    onClick={() => window.open('https://wa.me/584147552221', '_blank')}
                    className="w-full bg-cyan-500 hover:bg-cyan-600 text-white font-bold py-4 px-6 rounded-lg transition-all flex items-center justify-center gap-2 shadow-lg"
                  >
                    <MessageCircle className="w-5 h-5" />
                    Enviar Mensaje por WhatsApp
                  </button>
                  <button
                    onClick={() => window.location.href = 'mailto:impreplast12@gmail.com'}
                    className="w-full bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold py-4 px-6 rounded-lg transition-all flex items-center justify-center gap-2"
                  >
                    <Mail className="w-5 h-5" />
                    Enviar Email
                  </button>
                </div>

                <div className="mt-6 pt-6 border-t border-white/10">
                  <p className="text-sm text-gray-400 mb-3">¿Por qué elegirnos?</p>
                  <ul className="space-y-2 text-sm text-gray-300">
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-green-400 flex-shrink-0" />
                      Respuesta en menos de 1 hora
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-green-400 flex-shrink-0" />
                      Cotización sin compromiso
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-green-400 flex-shrink-0" />
                      Asesoría profesional incluida
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-white mb-4 tracking-wider">
            IMPREPLASTICO
          </h2>
          <p className="text-gray-400">© 2025 Impreplastico - Todos los derechos reservados</p>
        </div>
      </footer>

      {/* WhatsApp Flotante */}
      <a
        href="https://wa.me/584147552221"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all hover:scale-110 z-40"
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle className="w-7 h-7" />
      </a>

      {/* Chatbot */}
      <AIChatbot isOpen={showChat} onClose={() => setShowChat(false)} />
      <PurchaseModal 
        isOpen={purchaseModalOpen} 
        onClose={() => setPurchaseModalOpen(false)} 
        orderData={selectedOrder}
        tasaBcv={tasaBcv}
      />
      <ComboModal
        isOpen={comboModalOpen}
        onClose={() => setComboModalOpen(false)}
        tasaBcv={tasaBcv}
        alfombrasOrderData={alfombrasOrderData}
      />
      <BagPurchaseModal
        isOpen={bagPurchaseOpen}
        onClose={() => setBagPurchaseOpen(false)}
        orderData={bagOrderData}
        tasaBcv={tasaBcv}
      />
      <CartDrawer
        isOpen={cartDrawerOpen}
        onClose={() => setCartDrawerOpen(false)}
        items={cartItems}
        tasaBcv={tasaBcv}
        onRemove={handleRemoveCartItem}
        onCheckout={() => { setCartDrawerOpen(false); setCartCheckoutOpen(true); }}
      />
      <CartCheckoutModal
        isOpen={cartCheckoutOpen}
        onClose={() => setCartCheckoutOpen(false)}
        items={cartItems}
        tasaBcv={tasaBcv}
        onSuccess={() => setCartItems([])}
      />

      {/* Marketing / UX conversion boosters */}
      <ProactiveWhatsAppBubble />
      <LeadMagnetPopup />
      <MobileFloatingBar cartCount={cartItems.length} onOpenCart={() => setCartDrawerOpen(true)} />
    </div>
    )}
    </>
  );
}

export default App;